(function () {
  window.bloomingfulWsaioCompatVersion = 'ruscus-wednesday-shipping-20261002-55';
  window.bloomingfulPublicWs01Event = { id: 'coneflower-public-ws01-2026-08-16', endsAt: '2026-09-09T07:00:00.000Z' };

  var retryTimer = null;
  var observer = null;
  var pendingCartRequest = null;
  var lastWsaioDiscountCents = 0;
  var delegatedCheckoutBound = false;
  var wsaioDisplayStorageKey = 'bloomingful:wsaioCartDisplay';
  var savingsColor = '#ad807f';
  var wholesaleShippingMessage = 'Standard Wholesale Shipping (Ground 2-5 business days). Message us for 1-Day, 2-Day, or 3-Day expedited shipping upgrades.';
  var freshShippingMessage = 'FedEx 1-Day shipping is included for Fresh greenery and garlands.';
  var bouquetShippingMessage = 'Bouquet shipping is based on your selected delivery date.';
  var mixedShippingMessage = 'Fresh items ship by FedEx 1-Day (included). Other items use the applicable shipping or handling rate shown at checkout.';
  var isApplyingWsaioDomUpdates = false;
  var applyingReleaseTimer = null;
  var checkoutCleanupTimer = null;
  var collectionPriceTimer = null;
  var visibleLinePriceTimers = [];
  var cartTotalTimers = [];
  var cartTotalDeadlineTimer = null;
  var lastCartFetchAt = 0;
  var cartCacheTtlMs = 1500;

  function beginDomUpdatePhase() {
    isApplyingWsaioDomUpdates = true;
    window.clearTimeout(applyingReleaseTimer);
  }

  function scheduleDomUpdatePhaseRelease(delayMs) {
    window.clearTimeout(applyingReleaseTimer);
    applyingReleaseTimer = window.setTimeout(function () {
      isApplyingWsaioDomUpdates = false;
    }, delayMs);
  }

  function runWholesaleChecks() {
    var freshCompatibilityAdded;
    var hasWsaioRuntime = Boolean(window.WSAIO);

    syncWsaioCustomerFromStorefront();
    if (hasWsaioRuntime) {
      freshCompatibilityAdded = syncFreshWsaioCollectionCompatibility();
      wrapWsaioCheckoutRequests();
      if (freshCompatibilityAdded) refreshFreshWsaioPreCheckout();
    }
    refreshCartData()
      .then(function () {
        invokeWholesaleChecks();
      })
      .catch(function () {
        invokeWholesaleChecks();
      });

    return hasWsaioRuntime;
  }

  function refreshCartData() {
    if (typeof window.fetch !== 'function') return Promise.resolve(window.cart_data);
    if (pendingCartRequest) return pendingCartRequest;

    if (window.cart_data && (Date.now() - lastCartFetchAt) < cartCacheTtlMs) {
      return Promise.resolve(window.cart_data);
    }

    pendingCartRequest = window.fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      })
      .then(function (cart) {
        window.cart_data = cart;
        lastCartFetchAt = Date.now();
        return cart;
      })
      .catch(function () {})
      .then(function (cart) {
        pendingCartRequest = null;
        return cart;
      });

    return pendingCartRequest;
  }

  function invokeWholesaleChecks() {
    if (isApplyingWsaioDomUpdates) return;
    beginDomUpdatePhase();

    try {
      syncWsaioCustomerFromStorefront();
      syncWholesaleSelectors();

      if (pageNeedsWsaioDraftCheckout()) {
        if (typeof window.WSAIO.load_checkout_restriction === 'function') {
          window.WSAIO.load_checkout_restriction();
        } else if (typeof window.WSAIO.checkout_restriction === 'function') {
          window.WSAIO.checkout_restriction();
        } else {
          if (typeof window.WSAIO.order_control === 'function') window.WSAIO.order_control();
          if (typeof window.WSAIO.cartQuantityControllers === 'function') window.WSAIO.cartQuantityControllers();
          if (typeof window.WSAIO.loadcartQuantityControllers === 'function') window.WSAIO.loadcartQuantityControllers();
        }
        if (typeof window.WSAIO.run_checkout === 'function') {
          window.WSAIO.run_checkout();
        }
      }
      normalizeWholesaleShippingMessages();
      normalizeDiscountColors();
      scheduleCheckoutControlCleanup();
      syncWsaioDiscountInputs();
      clearWsaioCheckoutRuntimeMessages();
      window.setTimeout(normalizeWsaioCartTotals, 50);
      scheduleWsaioVisibleLinePriceNormalization();
      window.setTimeout(normalizeDiscountColors, 75);
      window.setTimeout(scheduleCheckoutControlCleanup, 125);
      window.setTimeout(syncWsaioDiscountInputs, 150);
    } catch (error) {
      console.warn('Wholesale All In One compatibility check failed', error);
    } finally {
      scheduleDomUpdatePhaseRelease(2200);
    }
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function setMoneyHtmlIfDifferent(element, cents) {
    if (!element || !cents || parseMoneyCents(element.textContent) === Number(cents)) return false;
    element.innerHTML = formatMoney(Number(cents));
    return true;
  }

  function parseDiscountCents(text) {
    var match = String(text || '').match(/additional\s+\$?\s*([\d,]+(?:\.\d{1,2})?)\s+discount\s+will\s+be\s+applied\s+at\s+checkout/i);
    if (!match) return 0;

    return Math.round(Number(match[1].replace(/,/g, '')) * 100);
  }

  function parseMoneyCents(text) {
    var match = String(text || '').match(/([\d,]+(?:\.\d{1,2})?)/);

    if (!match) return 0;

    return Math.round(Number(match[1].replace(/,/g, '')) * 100);
  }

  function getCartItemQuantity(itemElement) {
    var quantityInput = itemElement && itemElement.querySelector('[name="updates[]"], .js-qty__num');

    return quantityInput ? Number(quantityInput.value) || 0 : 0;
  }

  function getCartItemUnitPriceCents(itemElement) {
    var priceElement;
    var resolvedUnitCents;

    if (!itemElement) return 0;

    resolvedUnitCents = Number(itemElement.dataset && itemElement.dataset.bfWsaioResolvedUnitCents) || 0;
    if (resolvedUnitCents) return resolvedUnitCents;

    priceElement = itemElement.querySelector('.cart__item-price-col .cart__discount:not(small), .cart__item-price-col .cart__price:not(.cart__price--strikethrough)');

    return parseMoneyCents(priceElement && priceElement.textContent);
  }

  function getDisplayedCartItemUnitPriceCents(itemElement) {
    var candidates;
    var matched = 0;

    if (!itemElement) return 0;

    candidates = itemElement.querySelectorAll('.cart__item-price-col .bf-cart-discount-price, .cart__item-price-col .cart__discount:not(small), .cart__item-price-col .cart__price:not(.cart__price--strikethrough)');
    Array.prototype.some.call(candidates, function (element) {
      var style = element.style || {};
      var cents;

      if (element.hidden || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      cents = parseMoneyCents(element.textContent);
      if (!cents) return false;
      matched = cents;
      return true;
    });

    return matched;
  }

  function getVisibleLineSubtotalCents(form) {
    var subtotalCents = 0;

    form.querySelectorAll('.cart__item').forEach(function (itemElement) {
      subtotalCents += getCartItemUnitPriceCents(itemElement) * getCartItemQuantity(itemElement);
    });

    return subtotalCents;
  }

  function getCartSubtotalCents(form) {
    var ajaxItems = form.querySelector('.cart__items[data-cart-subtotal]');
    var visibleLineSubtotalCents = getVisibleLineSubtotalCents(form);

    if (visibleLineSubtotalCents) {
      return visibleLineSubtotalCents;
    }

    if (ajaxItems && ajaxItems.dataset.cartSubtotal) {
      return Number(ajaxItems.dataset.cartSubtotal) || 0;
    }

    if (window.cart_data && typeof window.cart_data.total_price === 'number') {
      return window.cart_data.total_price;
    }

    var subtotal = form.querySelector('[data-subtotal]');
    if (!subtotal) return 0;

    if (!subtotal.dataset.bfBaseSubtotalCents) {
      var subtotalCents = parseMoneyCents(subtotal.textContent);
      if (subtotalCents) {
        subtotal.dataset.bfBaseSubtotalCents = String(subtotalCents);
      }
    }

    return Number(subtotal.dataset.bfBaseSubtotalCents) || 0;
  }

  function getVisibleCartSubtotalCents() {
    var form = document.querySelector('#CartPageForm') || document.querySelector('#CartDrawerForm');
    return form ? getCartSubtotalCents(form) : 0;
  }

  function findWsaioFutureDiscountCents(form) {
    var discountCents = 0;

    form.querySelectorAll('[data-wsaio-messages], [class*="wsaio" i], [id*="wsaio" i]').forEach(function (element) {
      if (element.classList && element.classList.contains('bf-wsaio-applied-summary')) return;
      discountCents = Math.max(discountCents, parseDiscountCents(element.textContent));
    });

    return discountCents;
  }

  function findPageWsaioFutureDiscountCents() {
    var discountCents = 0;

    document.querySelectorAll('#CartPageForm [data-wsaio-messages], #CartDrawerForm [data-wsaio-messages], #CartPageForm [class*="wsaio" i], #CartDrawerForm [class*="wsaio" i]').forEach(function (element) {
      if (element.classList && element.classList.contains('bf-wsaio-applied-summary')) return;
      discountCents = Math.max(discountCents, parseDiscountCents(element.textContent));
    });

    if (discountCents) {
      lastWsaioDiscountCents = discountCents;
    }

    return discountCents || lastWsaioDiscountCents;
  }

  function storeWsaioDisplayDiscount(baseSubtotalCents, discountCents) {
    if (!baseSubtotalCents || !discountCents) return;

    try {
      window.sessionStorage.setItem(wsaioDisplayStorageKey, JSON.stringify({
        baseSubtotalCents: baseSubtotalCents,
        discountCents: discountCents,
        storedAt: Date.now()
      }));
    } catch (error) {
    }
  }

  function getStoredWsaioDisplayDiscount(baseSubtotalCents) {
    var stored;

    if (hasWsaioCustomerPricingAccess()) return 0;

    try {
      stored = JSON.parse(window.sessionStorage.getItem(wsaioDisplayStorageKey) || 'null');
    } catch (error) {
      stored = null;
    }

    if (!stored || stored.baseSubtotalCents !== baseSubtotalCents || !stored.discountCents) return 0;
    if (Date.now() - Number(stored.storedAt || 0) > 10 * 60 * 1000) return 0;

    return Number(stored.discountCents) || 0;
  }

  function getDiscountDisplayLabel() {
    var orderDiscount = getBestWsaioOrderDiscount(getVisibleCartSubtotalCents());

    if (orderDiscount && orderDiscount.label) {
      return 'Discount code: ' + orderDiscount.label;
    }

    if (hasWsaioCustomerPricingAccess()) {
      return 'Wholesale Discount';
    }

    if (/25%\s+off\s+retail\s+orders\s+of\s+\$150\+/i.test(document.body.textContent || '')) {
      return 'Discount code: SAVE25DRIED';
    }

    return 'Discount';
  }

  function getCustomerTagText() {
    var tags = window.WSAIO && window.WSAIO.customer && window.WSAIO.customer.tags;
    var storefrontTags = Array.isArray(window.bloomingfulCustomerTags) ? window.bloomingfulCustomerTags.join(',') : '';

    return String(tags || '') + ',' + storefrontTags;
  }

  function syncWsaioCustomerFromStorefront() {
    var info = window.bloomingfulCustomerInfo || {};
    var tags = Array.isArray(info.tags) ? info.tags : window.bloomingfulCustomerTags;

    if (!window.WSAIO || (!info.id && (!Array.isArray(tags) || !tags.length))) return;

    window.WSAIO.customer = window.WSAIO.customer || {};
    if (info.id) window.WSAIO.customer.id = info.id;
    if (info.email) window.WSAIO.customer.email = info.email;
    if (Array.isArray(tags)) {
      window.WSAIO.customer.tags = tags.map(function (tag) {
        return String(tag || '').trim().toLowerCase();
      }).filter(Boolean);
    }
  }

  function isPublicWs01EventActive() {
    var event = window.bloomingfulPublicWs01Event;
    var endsAt = Date.parse(event && event.endsAt || '');
    return Boolean(event && event.id === 'coneflower-public-ws01-2026-08-16' && endsAt && Date.now() < endsAt);
  }

  function hasWs01Access() {
    return Boolean(window.bloomingfulCustomerHasWholesaleAccess) ||
      /(^|,|\s)ws01($|,|\s)/i.test(getCustomerTagText());
  }

  function hasWsaioCustomerPricingAccess() {
    var rules = mergeWsaioRuleSources();
    var customerGroupRules = window.bloomingfulWsaioCustomerGroups && Array.isArray(window.bloomingfulWsaioCustomerGroups.rules)
      ? window.bloomingfulWsaioCustomerGroups.rules
      : [];

    if (hasWs01Access() || isPublicWs01EventActive() || hasWsaioLinePricingAdjustment()) return true;

    return rules.some(function (rule) {
      return ruleAppliesToCustomer(rule) && getRuleCustomerSpecificity(rule) > 1;
    }) || customerGroupRules.some(function (rule) {
      return ruleAppliesToCustomer(rule) && getRuleCustomerSpecificity(rule) > 1;
    });
  }

  function getFallbackWsaioDiscountCents() {
    var cart = window.cart_data;
    var eligibleCollections = [{ id: '323906371735', handle: 'discount-eligible-products-all' }];
    var eligibleSubtotalCents = 0;

    if (hasWsaioCustomerPricingAccess() || !cart || !Array.isArray(cart.items)) return 0;
    if (Number(cart.total_discount || 0) > 0 || cart.items.some(function (item) { return Number(item.total_discount || 0) > 0; })) return 0;

    cart.items.forEach(function (item) {
      if (!itemMatchesWsaioCollections(item, eligibleCollections)) return;
      eligibleSubtotalCents += Number(item.final_line_price || item.original_line_price || 0) || 0;
    });

    if (eligibleSubtotalCents < 15000) return 0;
    return Math.round(eligibleSubtotalCents * 0.25);
  }

  function syncWsaioVisibleLinePrices() {
    var cart = window.cart_data;

    if (!hasWsaioCustomerPricingAccess() || !cart || !Array.isArray(cart.items)) return;

    document.querySelectorAll('#CartPageForm .cart__item, #CartDrawerForm .cart__item').forEach(function (itemElement) {
      var key = itemElement.getAttribute('data-key');
      var item = cart.items.filter(function (cartItem) {
        return cartItem.key === key;
      })[0];
      var fixedUnitPriceCents = getWsaioFixedUnitPriceCents(item);
      var originalUnitPriceCents = Number(item && (item.original_price || item.price)) || 0;
      var priceColumn = itemElement.querySelector('.cart__item-price-col');
      var visibleDiscount = priceColumn && priceColumn.querySelector('.bf-cart-discount-price');
      var visibleCompare = priceColumn && priceColumn.querySelector('.bf-cart-compare-price');

      if (!priceColumn || !fixedUnitPriceCents || !originalUnitPriceCents || originalUnitPriceCents <= fixedUnitPriceCents) return;

      itemElement.dataset.bfWsaioResolvedUnitCents = String(fixedUnitPriceCents);
      if (
        visibleDiscount &&
        visibleCompare &&
        parseMoneyCents(visibleDiscount.textContent) === fixedUnitPriceCents &&
        parseMoneyCents(visibleCompare.textContent) === originalUnitPriceCents
      ) {
        priceColumn.classList.add('bf-cart-price-stack');
        return;
      }

      priceColumn.classList.add('bf-cart-price-stack');
      priceColumn.innerHTML = '<span class="visually-hidden">Sale price</span>' +
        '<span class="cart__price cart__discount bf-cart-discount-price">' + formatMoney(fixedUnitPriceCents) + '</span>' +
        '<span class="visually-hidden">Regular price</span>' +
        '<small class="cart__price cart__price--strikethrough bf-cart-compare-price">' + formatMoney(originalUnitPriceCents) + '</small>';
    });

    syncResolvedWsaioCartSubtotals();
  }

  function syncResolvedWsaioCartSubtotals() {
    document.querySelectorAll('#CartPageForm, #CartDrawerForm').forEach(function (form) {
      var subtotalCents = getVisibleLineSubtotalCents(form);
      var orderDiscount = getBestWsaioOrderDiscount(subtotalCents);
      var subtotal = form.querySelector('[data-subtotal], .total.row > :last-child, .bf-wsaio-estimated-total-row > :last-child');
      var totalRow = form.querySelector('.total.row');
      var label = totalRow && totalRow.querySelector('div:first-child');

      if (!subtotalCents || !subtotal) return;
      if (orderDiscount) subtotalCents -= orderDiscount.discountCents;
      if (subtotalCents <= 0) return;



      if (totalRow) totalRow.classList.add('bf-wsaio-estimated-total-row');
      if (label) label.textContent = 'Estimated total';
      setMoneyHtmlIfDifferent(subtotal, subtotalCents);
    });
  }

  function scheduleWsaioVisibleLinePriceNormalization() {
    [25, 175, 650, 1500, 3000].forEach(function (delayMs, index) {
      window.clearTimeout(visibleLinePriceTimers[index]);
      visibleLinePriceTimers[index] = window.setTimeout(syncWsaioVisibleLinePrices, delayMs);
    });
  }

  function getMatchingWsaioTagOption(tagOptions) {
    var matched = null;

    if (!Array.isArray(tagOptions)) return null;

    tagOptions.forEach(function (option) {
      var optionName = String(option && option.name || '');
      var specificity = getWsaioTagSpecificity(optionName);

      if (!option || !option.value || !specificity || !/^(fixed_price|price_discount|percentage)$/i.test(String(option.type || ''))) return;
      if (!matched || specificity > matched.specificity || (specificity === matched.specificity && centsFromFixedValue(option.value) < centsFromFixedValue(matched.option.value))) {
        matched = {
          option: option,
          specificity: specificity
        };
      }
    });

    return matched;
  }

  function getWsaioTagSpecificity(tag) {
    var tagText = String(tag || '');
    var customerTags = getCustomerTagText();

    if (!tagText) return 0;
    if (/^ws01$/i.test(tagText) && hasWs01Access()) return 3;
    if (!/^all$/i.test(tagText) && new RegExp('(^|,|\\s)' + tagText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|,|\\s)', 'i').test(customerTags)) return 2;
    if (/^all$/i.test(tagText)) return 1;

    return 0;
  }

  function customerMatchesWsaioTag(tag) {
    return Boolean(getWsaioTagSpecificity(tag));
  }

  function ruleAppliesToCustomer(rule) {
    if (!rule || rule.state === 'unpublished') return false;
    var tagsExcluded = Array.isArray(rule.tags_excluded) ? rule.tags_excluded : rule.tagsExcluded;
    var customerGroup = rule.customer_group || rule.customerGroup || '';
    var tags = Array.isArray(rule.tags) ? rule.tags : [];

    if (Array.isArray(tagsExcluded) && tagsExcluded.some(function (tag) {
      return customerMatchesWsaioTag(tag);
    })) return false;
    if (customerGroup === 'all') return true;
    if (customerGroup === 'tag_based' && !tags.length) return false;
    if (!tags.length) return false;

    return tags.some(function (tag) {
      return customerMatchesWsaioTag(tag);
    });
  }

  function centsFromFixedValue(value) {
    var number = Number(String(value || '').replace(/[^0-9.]/g, ''));

    return number ? Math.round(number * 100) : 0;
  }

  function centsFromWsaioValue(value, type, originalUnitPriceCents, preferFixedDecimals) {
    var stringValue = String(value || '');
    var number = Number(stringValue.replace(/[^0-9.]/g, ''));

    if (!number) return 0;
    if (type === 'fixed_price' || type === 'price_discount') return Math.round(number * 100);
    if (type === 'percentage' && preferFixedDecimals && stringValue.indexOf('.') !== -1 && Math.round(number * 100) < originalUnitPriceCents) return Math.round(number * 100);
    if (type === 'percentage' && originalUnitPriceCents) return Math.round(originalUnitPriceCents * (1 - number / 100));

    return 0;
  }

  function collectWsaioFixedPriceCandidates(rule, item) {
    var candidates = [];
    var products = Array.isArray(rule && rule.products) ? rule.products : [];
    var itemProductId = String(item && item.product_id || '');
    var itemVariantId = String(item && item.variant_id || item && item.id || '');
    var itemSku = String(item && item.sku || '');
    var itemHandle = String(item && item.handle || '');

    if (rule.applies_to === 'collections' || rule.appliesTo === 'collections') {
      collectWsaioCollectionRuleCandidates(rule, item).forEach(function (candidate) {
        candidates.push(candidate);
      });
    }

    products.forEach(function (productRule) {
      var productMatches = String(productRule.id || '') === itemProductId || String(productRule.handle || '') === itemHandle;

      if (!productMatches) return;

      if (Array.isArray(productRule.variants) && productRule.variants.length) {
        productRule.variants.forEach(function (variantRule) {
          var variantMatches = String(variantRule.id || '') === itemVariantId || String(variantRule.sku || '') === itemSku;
          var tagMatch = getMatchingWsaioTagOption(variantRule.tag_options || variantRule.tagOptions);
          var quantity = Number(variantRule.quantity || productRule.quantity || 1) || 1;
          var priceCents = tagMatch ? centsFromWsaioValue(tagMatch.option.value, tagMatch.option.type || rule.discount_type || rule.discountType, originalUnitPriceCents(item), false) : 0;

          if (variantMatches && priceCents) {
            candidates.push({ qty: quantity, priceCents: priceCents, specificity: tagMatch.specificity });
          }
        });
        return;
      }

      var productTagMatch = getMatchingWsaioTagOption(productRule.tag_options || productRule.tagOptions);
      var productPriceCents = productTagMatch ? centsFromWsaioValue(productTagMatch.option.value, productTagMatch.option.type || rule.discount_type || rule.discountType, originalUnitPriceCents(item), false) : 0;
      if (productPriceCents) {
        candidates.push({ qty: Number(productRule.quantity || 1) || 1, priceCents: productPriceCents, specificity: productTagMatch.specificity });
      }

      if (!productPriceCents && (rule.discount_value || rule.discountValue) && productMatches) {
        var rulePriceCents = centsFromWsaioValue(rule.discount_value || rule.discountValue, rule.discount_type || rule.discountType, originalUnitPriceCents(item), false);
        var ruleSpecificity = getRuleCustomerSpecificity(rule);
        if (rulePriceCents && ruleSpecificity) {
          candidates.push({ qty: Number(productRule.quantity || 1) || 1, priceCents: rulePriceCents, specificity: ruleSpecificity });
        }
      }

      if (!isWsaioSentinelPercentageRule(rule)) {
        collectWsaioVolumeDiscountCandidates(rule, item, 3).forEach(function (candidate) {
          candidates.push(candidate);
        });
      }
    });

    return candidates;
  }

  function isWsaioSentinelPercentageRule(rule) {
    var quantityBreaks = Array.isArray(rule && rule.volume_discount) ? rule.volume_discount : rule && rule.volumeDiscount;
    var discountType = String(rule && (rule.discount_type || rule.discountType) || '');
    var shape = String(rule && rule.shape || '');
    var quantityBreak;

    if (shape !== 'individual_volume_pricing' || discountType !== 'percentage' || !Array.isArray(quantityBreaks) || quantityBreaks.length !== 1) return false;
    quantityBreak = quantityBreaks[0] || {};

    // WSAIO stores a 1% placeholder on some individual-price rules. The actual
    // configured prices are the product/variant tag options, not this sentinel.
    return Number(quantityBreak.qty || quantityBreak.quantity || 0) === 1 &&
      Number(quantityBreak.value || quantityBreak.discount_value || 0) === 1;
  }

  function collectWsaioCollectionRuleCandidates(rule, item) {
    var candidates = [];
    var excludedProducts = Array.isArray(rule.exclude_products) ? rule.exclude_products : rule.excludeProducts;
    var collections = Array.isArray(rule.collections) ? rule.collections : [];
    var quantityBreaks = Array.isArray(rule.volume_discount) ? rule.volume_discount : rule.volumeDiscount;
    var itemProductId = String(item && item.product_id || '');
    var itemHandle = String(item && item.handle || '');
    var ruleValue = rule.discount_value || rule.discountValue;
    var rulePriceCents = 0;

    if (isWsaioProductExcluded(excludedProducts, itemProductId, itemHandle)) return candidates;
    if (!itemMatchesWsaioCollections(item, collections)) return candidates;

    candidates = collectWsaioVolumeDiscountCandidates(rule, item, 2);
    if ((!Array.isArray(quantityBreaks) || !quantityBreaks.length) && ruleValue) {
      rulePriceCents = centsFromWsaioValue(
        ruleValue,
        rule.discount_type || rule.discountType,
        originalUnitPriceCents(item),
        false
      );
      if (rulePriceCents) {
        candidates.push({ qty: 1, priceCents: rulePriceCents, specificity: 2 });
      }
    }

    return candidates;
  }

  function collectWsaioVolumeDiscountCandidates(rule, item, specificity) {
    var candidates = [];
    var quantityBreaks = Array.isArray(rule.volume_discount) ? rule.volume_discount : rule.volumeDiscount;
    var itemOriginalUnitPriceCents = Number(item && (item.original_price || item.price)) || 0;

    if (!Array.isArray(quantityBreaks) || !quantityBreaks.length) return candidates;

    quantityBreaks.forEach(function (quantityBreak) {
      var qty = Number(quantityBreak.qty || quantityBreak.quantity || 1) || 1;
      var value = Number(quantityBreak.value || quantityBreak.discount_value || 0) || 0;
      var priceCents = 0;

      priceCents = centsFromWsaioValue(value, rule.discount_type || rule.discountType, itemOriginalUnitPriceCents, true);

      if (priceCents) {
        candidates.push({ qty: qty, priceCents: priceCents, specificity: specificity });
      }
    });

    return candidates;
  }

  function originalUnitPriceCents(item) {
    return Number(item && (item.original_price || item.price)) || 0;
  }

  function getRuleCustomerSpecificity(rule) {
    var tags = Array.isArray(rule && rule.tags) ? rule.tags : [];
    var best = 0;

    if ((rule.customer_group || rule.customerGroup) === 'all') return 1;
    tags.forEach(function (tag) {
      best = Math.max(best, getWsaioTagSpecificity(tag));
    });

    return best;
  }

  function isWsaioProductExcluded(excludedProducts, productId, handle) {
    if (!Array.isArray(excludedProducts)) return false;

    return excludedProducts.some(function (product) {
      return String(product.id || '') === String(productId || '') || String(product.handle || '') === String(handle || '');
    });
  }

  function itemMatchesWsaioCollections(item, ruleCollections) {
    var ruleMap = window.bloomingfulWsaioRuleMap || {};
    var storefrontRuleMap = window.bloomingfulWsaioStorefrontPricing || {};
    var productId = String(item && item.product_id || '');
    var handle = String(item && item.handle || '');
    var itemCollections = (ruleMap.productCollectionsById && ruleMap.productCollectionsById[productId]) ||
      (ruleMap.productCollectionsByHandle && ruleMap.productCollectionsByHandle[handle]) ||
      (storefrontRuleMap.productCollectionsById && storefrontRuleMap.productCollectionsById[productId]) ||
      [];

    if (!Array.isArray(ruleCollections) || !ruleCollections.length || !Array.isArray(itemCollections) || !itemCollections.length) return false;

    return ruleCollections.some(function (ruleCollection) {
      return itemCollections.some(function (itemCollection) {
        return String(ruleCollection.id || '') === String(itemCollection.id || '') ||
          String(ruleCollection.handle || '') === String(itemCollection.handle || '');
      });
    });
  }

  function getWsaioFixedUnitPriceCents(item) {
    var rules = mergeWsaioRuleSources();
    var quantity = Number(item && item.quantity) || 0;
    var best = null;

    if (!rules.length || !quantity) return null;

    rules.forEach(function (rule) {
      if (!ruleAppliesToCustomer(rule)) return;

      collectWsaioFixedPriceCandidates(rule, item).forEach(function (candidate) {
        if (!best && quantity >= candidate.qty) {
          best = candidate;
          return;
        }

        if (
          quantity >= candidate.qty &&
          (
            candidate.specificity > best.specificity ||
            (candidate.specificity === best.specificity && candidate.qty > best.qty) ||
            (candidate.specificity === best.specificity && candidate.qty === best.qty && candidate.priceCents < best.priceCents)
          )
        ) {
          best = candidate;
        }
      });
    });

    return best ? best.priceCents : null;
  }

  function hasWsaioLinePricingAdjustment() {
    var cart = window.cart_data;

    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      var fixedUnitPriceCents = getWsaioFixedUnitPriceCents(item);
      var originalUnitPriceCents = Number(item && (item.original_price || item.price)) || 0;

      return fixedUnitPriceCents && originalUnitPriceCents && fixedUnitPriceCents < originalUnitPriceCents;
    });
  }

  function hasMatchingWsaioShippingRule() {
    var rules = [];

    if (window.bloomingfulWsaioRuleMap && Array.isArray(window.bloomingfulWsaioRuleMap.shippingRules)) {
      rules = rules.concat(window.bloomingfulWsaioRuleMap.shippingRules);
    }
    if (window.bloomingfulWsaioCustomerGroups && Array.isArray(window.bloomingfulWsaioCustomerGroups.shippingRules)) {
      rules = rules.concat(window.bloomingfulWsaioCustomerGroups.shippingRules);
    }

    return rules.some(function (rule) {
      return ruleAppliesToCustomer(normalizeMappedWsaioShippingRule(rule));
    });
  }

  function needsWsaioDraftCheckout(form) {
    if (!form || !window.WSAIO || typeof window.WSAIO.checkout !== 'function') return false;
    if (getRuscusWednesdayShippingFee(window.cart_data) > 0) return true;
    if (hasWsaioLinePricingAdjustment()) return true;
    if (hasMatchingWsaioShippingRule()) return true;
    if (hasWsaioCustomerPricingAccess() && hasVisibleWsaioDiscount(form)) return true;

    return false;
  }

  function pageNeedsWsaioDraftCheckout() {
    return Array.prototype.slice.call(document.querySelectorAll('#CartPageForm, #CartDrawerForm')).some(function (form) {
      return needsWsaioDraftCheckout(form);
    });
  }

  function getBestWsaioOrderDiscount(baseSubtotalCents) {
    var rules = getWsaioOrderDiscountRules();
    var best = null;

    if (!baseSubtotalCents || !rules.length) return null;

    rules.forEach(function (rule) {
      if (!ruleAppliesToCustomer(rule)) return;

      var discounts = Array.isArray(rule.discounts) ? rule.discounts : [];
      var eligibleBreak = null;

      discounts.forEach(function (discount) {
        var thresholdCents = Math.round((Number(discount.threshold || discount.value || 0) || 0) * 100);
        if (baseSubtotalCents < thresholdCents) return;
        if (!eligibleBreak || thresholdCents >= eligibleBreak.thresholdCents) {
          eligibleBreak = {
            thresholdCents: thresholdCents,
            value: Number(discount.discount_value || discount.valueAmount || discount.discountValue || discount.value || 0) || 0
          };
        }
      });

      if (!eligibleBreak || !eligibleBreak.value) return;

      var discountType = rule.discount_type || rule.discountType || '';
      var discountCents = discountType === 'percentage'
        ? Math.round(baseSubtotalCents * (eligibleBreak.value / 100))
        : Math.round(eligibleBreak.value * 100);

      if (!discountCents) return;

      var candidate = {
        label: String(rule.title || rule.message || rule.key || 'Discount').replace(/\s*\{\{discount\}\}\s*/g, '').trim(),
        discountCents: discountCents,
        specificity: getRuleCustomerSpecificity(rule),
        thresholdCents: eligibleBreak.thresholdCents
      };

      if (!best || candidate.specificity > best.specificity || (candidate.specificity === best.specificity && candidate.thresholdCents > best.thresholdCents) || (candidate.specificity === best.specificity && candidate.thresholdCents === best.thresholdCents && candidate.discountCents > best.discountCents)) {
        best = candidate;
      }
    });

    return best;
  }

  function getWsaioOrderDiscountRules() {
    var rules = [];
    var seen = {};

    if (window.bloomingfulWsaioRuleMap && Array.isArray(window.bloomingfulWsaioRuleMap.cartLevelDiscountRules)) {
      window.bloomingfulWsaioRuleMap.cartLevelDiscountRules.forEach(function (rule) {
        var key = 'map-cart:' + String(rule.key || JSON.stringify(rule).slice(0, 80));
        if (seen[key]) return;
        seen[key] = true;
        rules.push(normalizeMappedWsaioOrderRule(rule));
      });
    }

    if (window.bloomingfulWsaioCustomerGroups && Array.isArray(window.bloomingfulWsaioCustomerGroups.cartLevelDiscountRules)) {
      window.bloomingfulWsaioCustomerGroups.cartLevelDiscountRules.forEach(function (rule) {
        var key = 'lightweight-cart:' + String(rule.key || JSON.stringify(rule).slice(0, 80));
        if (seen[key]) return;
        seen[key] = true;
        rules.push(normalizeMappedWsaioOrderRule(rule));
      });
    }

    if (window.WSAIO && window.WSAIO.wsaio_cart_ld) {
      Object.keys(window.WSAIO.wsaio_cart_ld).forEach(function (ruleKey) {
        var key = 'runtime-cart:' + ruleKey;
        if (seen[key]) return;
        seen[key] = true;
        rules.push(window.WSAIO.wsaio_cart_ld[ruleKey]);
      });
    }

    return rules;
  }

  function getStoredAffiliateOrderDiscountCode() {
    var promo;
    var startedAt;

    try {
      promo = JSON.parse(window.localStorage.getItem('bloomingful:affiliatePromo') || 'null');
    } catch (error) {
      promo = null;
    }

    if (!promo || !promo.code) return '';
    startedAt = Number(promo.startedAt || 0);
    if (startedAt && Date.now() - startedAt > 365 * 24 * 60 * 60 * 1000) return '';

    return String(promo.code || '').trim().toUpperCase();
  }

  function getAllowedWsaioOrderDiscountCodes() {
    var allowed = {};

    getWsaioOrderDiscountRules().forEach(function (rule) {
      var title = String(rule.title || rule.message || rule.key || '').replace(/\s*\{\{discount\}\}\s*/g, '').trim().toUpperCase();
      if (!title || !ruleAppliesToCustomer(rule)) return;
      allowed[title] = true;
    });

    if (getStoredAffiliateOrderDiscountCode() === 'CONE') allowed.CONE = true;

    return allowed;
  }

  function discountObjectCode(value) {
    var direct;
    var text;
    var match;

    if (!value) return '';
    if (typeof value === 'string') return value.trim().toUpperCase();

    if (typeof value === 'object') {
      direct = value.coupon_code || value.code || value.discount_code || value.discountCode;
      if (direct) return String(direct).trim().toUpperCase();

      if (value.price_rule && typeof value.price_rule === 'object') {
        direct = value.price_rule.coupon_code || value.price_rule.code;
        if (direct) return String(direct).trim().toUpperCase();

        text = String(value.price_rule.title || '').trim().toUpperCase();
        match = text.match(/^([A-Z0-9_-]{4,})(?:\s|$)/);
        if (match) return match[1];
      }
    }

    text = JSON.stringify(value).toUpperCase();
    match = text.match(/SAVE25DRIED|AFFREFER10|CONE/);
    return match ? match[0] : '';
  }

  function isAllowedWsaioOrderDiscountCode(code) {
    var normalizedCode = String(code || '').trim().toUpperCase();
    var allowedCodes = getAllowedWsaioOrderDiscountCodes();
    var hasAllowedCodes = Object.keys(allowedCodes).length > 0;

    if (!normalizedCode) return false;
    if (!hasWs01Access() && !hasWsaioCustomerPricingAccess()) return true;
    return hasAllowedCodes && Boolean(allowedCodes[normalizedCode]);
  }

  function ensureWsaioCheckoutCollectionCompleteness(payload) {
    var liveMap = window.bloomingfulWsaioStorefrontPricing || {};
    var fallbackMap = window.bloomingfulWsaioRuleMap || {};
    var completed = {};
    if (!payload || !payload.cart || !Array.isArray(payload.cart.items)) return payload;
    if (!Array.isArray(payload.products_with_collections)) payload.products_with_collections = [];
    payload.cart.items.forEach(function (item) {
      var productId = String(item.product_id || '');
      var handle = String(item.handle || '');
      var known = (liveMap.productCollectionsById && liveMap.productCollectionsById[productId]) ||
        (fallbackMap.productCollectionsById && fallbackMap.productCollectionsById[productId]) ||
        (fallbackMap.productCollectionsByHandle && fallbackMap.productCollectionsByHandle[handle]);
      var entries;
      var ids = [];
      function addIds(value) {
        String(value || '').split(',').forEach(function (id) {
          id = id.trim();
          if (id && ids.indexOf(id) === -1) ids.push(id);
        });
      }
      if (!productId || !Array.isArray(known) || !known.length) return;
      entries = payload.products_with_collections.filter(function (entry) {
        return String(entry && entry.product_id || '') === productId;
      });
      entries.forEach(function (entry) { addIds(entry.collection_id); });
      known.forEach(function (entry) { addIds(entry && typeof entry === 'object' ? entry.id : entry); });
      if (!ids.length) return;
      if (!entries.length) {
        entries = [{ product_id: item.product_id, product_handle: handle }];
        payload.products_with_collections.push(entries[0]);
      }
      entries.forEach(function (entry) { entry.collection_id = ids.join(','); });
      completed[productId] = true;
    });
    if (Array.isArray(payload.missing_products_with_collections)) {
      payload.missing_products_with_collections = payload.missing_products_with_collections.filter(function (id) {
        return !completed[String(id && typeof id === 'object' ? id.product_id : id)];
      });
    }
    return payload;
  }


  function ensureFreshCheckoutCollectionCompatibility(payload) {
    var oldCollectionId = '286046486679';
    var currentCollectionId = '286068605079';

    if (!payload || !Array.isArray(payload.products_with_collections)) return payload;

    payload.products_with_collections.forEach(function (entry) {
      var suppliedIds = String(entry && entry.collection_id || '').split(',').filter(Boolean);

      if (suppliedIds.indexOf(currentCollectionId) === -1 || suppliedIds.indexOf(oldCollectionId) !== -1) return;

      suppliedIds.push(oldCollectionId);
      entry.collection_id = suppliedIds.join(',');
    });

    return payload;
  }

  function syncFreshWsaioCollectionCompatibility() {
    var oldCollectionId = '286046486679';
    var currentCollectionId = '286068605079';
    var collectionLists;
    var added = false;

    if (!window.WSAIO) return false;

    collectionLists = [window.WSAIO.products_with_collections, window.WSAIO.product_collections];
    collectionLists.forEach(function (entries) {
      var currentEntries;

      if (!Array.isArray(entries)) return;

      currentEntries = entries.filter(function (entry) {
        return String(entry && entry.collection_id || '') === currentCollectionId;
      });

      currentEntries.forEach(function (entry) {
        var productId = String(entry && entry.product_id || '');
        var alreadyPresent = entries.some(function (candidate) {
          return String(candidate && candidate.product_id || '') === productId &&
            String(candidate && candidate.collection_id || '') === oldCollectionId;
        });

        if (alreadyPresent) return;
        entries.push(Object.assign({}, entry, { collection_id: oldCollectionId }));
        added = true;
      });
    });

    return added;
  }

  function refreshFreshWsaioPreCheckout() {
    if (
      window.bloomingfulFreshWsaioPreCheckoutRefreshed === true ||
      !window.WSAIO ||
      typeof window.WSAIO.preCheckout !== 'function' ||
      !/\/cart(?:$|[?#])/.test(window.location.pathname + window.location.search)
    ) return;

    window.bloomingfulFreshWsaioPreCheckoutRefreshed = true;
    window.setTimeout(function () {
      try {
        window.WSAIO.preCheckout();
      } catch (error) {
        console.warn('Bloomingful could not refresh the WSAIO Fresh pricing pre-check', error);
      }
    }, 150);
  }

  function getCartItemProperty(item, requestedName) {
    var properties = item && (item.properties || item.line_item_properties);
    var requested = String(requestedName || '').trim().toLowerCase();
    var parsed;
    var matchingKey;

    if (!properties || !requested) return '';
    if (typeof properties === 'string') {
      try {
        parsed = JSON.parse(properties);
        properties = parsed;
      } catch (error) {
        return '';
      }
    }

    if (Array.isArray(properties)) {
      parsed = properties.find(function (property) {
        return String(property && (property.name || property.key) || '').trim().toLowerCase() === requested;
      });
      return String(parsed && parsed.value || '').trim();
    }

    if (typeof properties !== 'object') return '';
    matchingKey = Object.keys(properties).find(function (key) {
      return String(key || '').trim().toLowerCase() === requested;
    });
    return matchingKey ? String(properties[matchingKey] || '').trim() : '';
  }

  function normalizeBouquetShippingTier(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return ['standard', 'express', 'expedited', 'rush'].indexOf(normalized) === -1 ? '' : normalized;
  }

  function bouquetShippingTierFromItem(item) {
    var tier = normalizeBouquetShippingTier(getCartItemProperty(item, 'Required Shipping Tier'));
    var fee;

    if (tier) return tier;
    fee = parseFloat(String(getCartItemProperty(item, 'Expedited Shipping Fee') || '').replace(/[^0-9.]/g, ''));
    if (fee >= 35) return 'rush';
    if (fee >= 25) return 'expedited';
    if (fee >= 15) return 'express';
    return 'standard';
  }

  function getRequiredBouquetShippingTier(cart) {
    var tiers = { standard: 0, express: 1, expedited: 2, rush: 3 };
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var bouquetItems = items.filter(isBouquetCartItem);
    var selectedTier = 'standard';

    if (!bouquetItems.length) return '';
    bouquetItems.forEach(function (item) {
      var itemTier = bouquetShippingTierFromItem(item);
      if (tiers[itemTier] > tiers[selectedTier]) selectedTier = itemTier;
    });
    return selectedTier;
  }

  function getRuscusWednesdayShippingFee(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.some(function (item) {
      var id = String(item && item.product_id || '').replace('gid://shopify/Product/', '');
      var handle = String(item && item.handle || '').toLowerCase();
      if (id !== '15405744521367' && handle !== 'fresh-italian-ruscus') return false;
      var date = getCartItemProperty(item, 'Requested delivery date');
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
      var parsed = new Date(date + 'T12:00:00Z');
      return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date && parsed.getUTCDay() === 3;
    }) ? 15 : 0;
  }

  function getWsaioCheckoutShippingLine(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var bouquetTier = getRequiredBouquetShippingTier(cart);
    var ruscusWednesdayFee = getRuscusWednesdayShippingFee(cart);
    var hasWholesaleHandlingItems;
    var tiers = {
      standard: { price: 0, title: 'Standard' },
      express: { price: 15, title: 'Express' },
      expedited: { price: 25, title: 'Expedited' },
      rush: { price: 35, title: 'Rush & Saturdays' }
    };
    var selected;

    if (!items.length) return null;
    if (!bouquetTier) {
      if (ruscusWednesdayFee) {
        hasWholesaleHandlingItems = items.some(function (item) { return !isFreshCartItem(item); });
        return {
          custom: true,
          price: (ruscusWednesdayFee + (hasWholesaleHandlingItems ? 20 : 0)).toFixed(2),
          title: 'FedEx 1-Day (Wednesday)' + (hasWholesaleHandlingItems ? ' + Wholesale Handling' : '')
        };
      }
      return cartContainsOnlyFreshItems(cart) ? {
        custom: true,
        price: '0.00',
        title: 'FedEx 1-Day (included)'
      } : null;
    }

    selected = tiers[bouquetTier];
    hasWholesaleHandlingItems = items.some(function (item) {
      return !isFreshCartItem(item) && !isBouquetCartItem(item);
    });

    return {
      custom: true,
      price: (selected.price + ruscusWednesdayFee + (hasWholesaleHandlingItems ? 20 : 0)).toFixed(2),
      title: selected.title + (ruscusWednesdayFee ? ' + Italian Ruscus Wednesday' : '') + (hasWholesaleHandlingItems ? ' + Wholesale Handling' : '')
    };
  }

  function sanitizeWsaioCheckoutPayload(payload) {
    var code;
    var shippingLine;

    syncWsaioCustomerFromStorefront();
    if (!payload || !window.WSAIO) return payload;

    payload.customer = window.WSAIO.customer || payload.customer;
    ensureWsaioCheckoutCollectionCompleteness(payload);
    ensureFreshCheckoutCollectionCompatibility(payload);

    shippingLine = getWsaioCheckoutShippingLine(payload.cart || window.cart_data);
    if (shippingLine) payload.custom_shipping_line = shippingLine;

    code = discountObjectCode(payload.discount_code_application);
    if (code && !isAllowedWsaioOrderDiscountCode(code)) {
      payload.discount_code_application = {};
    }

    if (payload.cart && payload.cart.attributes && payload.cart.attributes.discount && !isAllowedWsaioOrderDiscountCode(payload.cart.attributes.discount)) {
      delete payload.cart.attributes.discount;
    }

    return payload;
  }

  function removeIneligibleDiscountInputs(form) {
    var allowedCodes = getAllowedWsaioOrderDiscountCodes();
    var hasAllowedCodes = Object.keys(allowedCodes).length > 0;

    form.querySelectorAll('input[name="discount"]').forEach(function (input) {
      var code = String(input.value || '').trim().toUpperCase();

      if (!code) {
        input.remove();
        return;
      }

      if (hasWs01Access() || hasWsaioCustomerPricingAccess()) {
        if (!hasAllowedCodes || !allowedCodes[code]) input.remove();
      }
    });
  }

  function clearIneligibleWsaioRuntimeDiscounts() {
    var allowedCodes = getAllowedWsaioOrderDiscountCodes();
    var hasAllowedCodes = Object.keys(allowedCodes).length > 0;

    if (!window.WSAIO || (!hasWs01Access() && !hasWsaioCustomerPricingAccess())) return;

    ['discountCode', 'discount_code', 'coupon_code', 'couponCode'].forEach(function (key) {
      var code = String(window.WSAIO[key] || '').trim().toUpperCase();
      if (code && (!hasAllowedCodes || !allowedCodes[code])) window.WSAIO[key] = '';
    });

    if (window.WSAIO.DiscountCode && typeof window.WSAIO.DiscountCode === 'object') {
      var applicationCode = discountObjectCode(window.WSAIO.DiscountCode.application);
      if (applicationCode && (!hasAllowedCodes || !allowedCodes[applicationCode])) {
        window.WSAIO.DiscountCode.application = {};
      }
    }

    if (window.WSAIO.wsaio_cart_ld && typeof window.WSAIO.wsaio_cart_ld === 'object') {
      Object.keys(window.WSAIO.wsaio_cart_ld).forEach(function (ruleKey) {
        var rule = window.WSAIO.wsaio_cart_ld[ruleKey];
        if (!ruleAppliesToCustomer(rule)) {
          delete window.WSAIO.wsaio_cart_ld[ruleKey];
        }
      });
    }

    if (Array.isArray(window.WSAIO.cart_ld_discounts)) {
      window.WSAIO.cart_ld_discounts = window.WSAIO.cart_ld_discounts.filter(function (rule) {
        return ruleAppliesToCustomer(rule);
      });
    }
  }

  function wrapWsaioCheckoutRequests() {
    var allWrapped = true;

    if (!window.WSAIO) return;

    ['checkoutRequest', 'preCheckoutRequest'].forEach(function (methodName) {
      var original = window.WSAIO[methodName];
      var wrapped;

      if (typeof original !== 'function') {
        allWrapped = false;
        return;
      }
      if (original.bloomingfulCheckoutPayloadGuard === true) return;

      wrapped = function (payload, callback) {
        return original.call(window.WSAIO, sanitizeWsaioCheckoutPayload(payload), callback);
      };
      wrapped.bloomingfulCheckoutPayloadGuard = true;
      window.WSAIO[methodName] = wrapped;
    });

    window.WSAIO.bloomingfulCheckoutPayloadGuard = allWrapped;
  }

  function normalizeMappedWsaioOrderRule(rule) {
    return {
      key: rule.key,
      title: rule.title,
      message: rule.message,
      customer_group: rule.customerGroup,
      tags: rule.tags || [],
      tags_excluded: rule.tagsExcluded || [],
      discount_type: rule.discountType,
      calculation_type: rule.calculationType,
      allocation_method: rule.allocationMethod,
      discounts: (rule.discounts || []).map(function (discount) {
        return {
          value: discount.threshold,
          discount_value: discount.value
        };
      }),
      state: 'published'
    };
  }

  function normalizeMappedWsaioShippingRule(rule) {
    return {
      key: rule.key,
      customer_group: rule.customerGroup,
      tags: rule.tags || [],
      tags_excluded: rule.tagsExcluded || [],
      state: rule.status === 'active' ? 'published' : rule.status
    };
  }

  function mergeWsaioRuleSources() {
    var merged = [];
    var seen = {};

    if (!window.bloomingfulWsaioRuleMap && window.bloomingfulWsaioStorefrontPricing) {
      if (Array.isArray(window.bloomingfulWsaioStorefrontPricing.pricingRules)) {
        window.bloomingfulWsaioStorefrontPricing.pricingRules.forEach(function (rule) {
          var key = 'storefront-map:' + String(rule.key || JSON.stringify(rule).slice(0, 80));
          if (seen[key]) return;
          seen[key] = true;
          merged.push(normalizeMappedWsaioRule(rule));
        });
      }

      if (Array.isArray(window.bloomingfulWsaioStorefrontPricing.regularDiscountRules)) {
        window.bloomingfulWsaioStorefrontPricing.regularDiscountRules.forEach(function (rule) {
          var key = 'storefront-map-regular:' + String(rule.key || JSON.stringify(rule).slice(0, 80));
          if (seen[key]) return;
          seen[key] = true;
          merged.push(normalizeMappedWsaioRule(rule));
        });
      }
    }

    if (window.bloomingfulWsaioRuleMap && Array.isArray(window.bloomingfulWsaioRuleMap.pricingRules || window.bloomingfulWsaioRuleMap.rules)) {
      (window.bloomingfulWsaioRuleMap.pricingRules || window.bloomingfulWsaioRuleMap.rules).forEach(function (rule) {
        var key = 'map:' + String(rule.key || JSON.stringify(rule).slice(0, 80));
        if (seen[key]) return;
        seen[key] = true;
        merged.push(normalizeMappedWsaioRule(rule));
      });
    }

    if (window.bloomingfulWsaioRuleMap && Array.isArray(window.bloomingfulWsaioRuleMap.regularDiscountRules)) {
      window.bloomingfulWsaioRuleMap.regularDiscountRules.forEach(function (rule) {
        var key = 'map-regular:' + String(rule.key || JSON.stringify(rule).slice(0, 80));
        if (seen[key]) return;
        seen[key] = true;
        merged.push(normalizeMappedWsaioRule(rule));
      });
    }

    if (window.WSAIO && window.WSAIO.wsaiovd) {
      Object.keys(window.WSAIO.wsaiovd).forEach(function (ruleKey) {
        var key = 'runtime:' + ruleKey;
        if (seen[key]) return;
        seen[key] = true;
        merged.push(window.WSAIO.wsaiovd[ruleKey]);
      });
    }

    if (window.WSAIO && window.WSAIO.wsaiord) {
      Object.keys(window.WSAIO.wsaiord).forEach(function (ruleKey) {
        var key = 'runtime-regular:' + ruleKey;
        if (seen[key]) return;
        seen[key] = true;
        merged.push(window.WSAIO.wsaiord[ruleKey]);
      });
    }

    return merged;
  }

  function normalizeMappedWsaioRule(rule) {
    return {
      key: rule.key,
      customer_group: rule.customerGroup,
      tags: rule.tags || [],
      tags_excluded: rule.tagsExcluded || [],
      discount_type: rule.discountType,
      applies_to: rule.appliesTo,
      target_selection: rule.targetSelection,
      individual_product: rule.individualProduct,
      discount_value: rule.discountValue,
      shape: rule.shape,
      collections: rule.collections || [],
      exclude_products: rule.excludeProducts || [],
      products: (rule.products || []).map(function (product) {
        return {
          id: product.id,
          handle: product.handle,
          variant_level: product.variantLevel,
          quantity: product.quantity,
          tag_options: product.tagOptions || [],
          variants: (product.variants || []).map(function (variant) {
            return {
              id: variant.id,
              sku: variant.sku,
              price: variant.price,
              quantity: variant.quantity,
              tag_options: variant.tagOptions || []
            };
          })
        };
      }),
      volume_discount: rule.volumeDiscount || [],
      state: 'published'
    };
  }

  function normalizeCartPriceFormatting() {
    document.querySelectorAll('#CartDrawer .cart__item-price-col, #CartDrawerForm .cart__item-price-col, #CartPageForm .cart__item-price-col').forEach(function (priceColumn) {
      priceColumn.classList.add('bf-cart-price-stack');

      priceColumn.querySelectorAll('.cart__price--strikethrough, [style*="line-through"]').forEach(function (element) {
        element.classList.add('bf-cart-compare-price');
      });

      priceColumn.querySelectorAll('.cart__discount:not(small), .cart__price:not(.cart__price--strikethrough)').forEach(function (element) {
        if (element.classList.contains('bf-cart-compare-price')) return;
        if (element.classList.contains('cart__price') && !priceColumn.querySelector('.bf-cart-compare-price')) return;
        element.classList.add('bf-cart-discount-price');
      });

      priceColumn.querySelectorAll('.bf-cart-discount-price').forEach(function (element) {
        element.style.setProperty('order', '1');
        element.style.setProperty('color', savingsColor, 'important');
      });

      priceColumn.querySelectorAll('.bf-cart-compare-price').forEach(function (element) {
        element.style.setProperty('order', '2');
      });

      var appComparePrice = priceColumn.querySelector('.cart_comp_price');
      if (appComparePrice) appComparePrice.style.setProperty('margin-left', '0.35rem');
      priceColumn.querySelectorAll('.bf-cart-compare-price:not(.cart_comp_price)').forEach(function (element) {
        if (appComparePrice && appComparePrice.offsetParent !== null) {
          element.dataset.bfHiddenDuplicateComparePrice = 'true';
          element.style.display = 'none';
        } else if (element.dataset.bfHiddenDuplicateComparePrice === 'true') {
          delete element.dataset.bfHiddenDuplicateComparePrice;
          element.style.display = '';
        }
      });
    });

    document.querySelectorAll('#CartDrawer .cart__discounts, #CartDrawerForm .cart__discounts, #CartPageForm .cart__discounts, #CartDrawer .bf-wsaio-applied-summary, #CartDrawerForm .bf-wsaio-applied-summary, #CartPageForm .bf-wsaio-applied-summary').forEach(function (element) {
      element.classList.add('bf-cart-discount-summary');
    });
  }

  function normalizeWsaioCartTotals() {
    var pageDiscountCents = findPageWsaioFutureDiscountCents();

    document.querySelectorAll('#CartPageForm, #CartDrawerForm').forEach(function (form) {
      suppressRetailCartDiscountRowsForWholesale(form);
      suppressRetailLineDiscountLabelsForWholesale(form);

      var totalRow = form.querySelector('.total.row');
      // WSAIO can replace the drawer footer and remove Shopify's data-subtotal
      // marker. Update the visible total cell in either footer shape.
      var subtotal = form.querySelector('[data-subtotal], .total.row > :last-child, .bf-wsaio-estimated-total-row > :last-child');
      if (!totalRow || !subtotal) return;

      syncWsaioVisibleLinePrices();

      var baseSubtotalCents = getCartSubtotalCents(form);
      var orderDiscount = getBestWsaioOrderDiscount(baseSubtotalCents);
      var discountCents = orderDiscount ? orderDiscount.discountCents : 0;
      var existingRow = form.querySelector('.bf-wsaio-applied-summary');
      var label = totalRow.querySelector('div:first-child');
      var hasCustomerPricing = hasWsaioCustomerPricingAccess();

      if (hasCustomerPricing && !discountCents) {
        if (existingRow) existingRow.remove();
        totalRow.classList.add('bf-wsaio-estimated-total-row');
        if (label) label.textContent = 'Estimated total';
        if (baseSubtotalCents) setMoneyHtmlIfDifferent(subtotal, baseSubtotalCents);
        normalizeWholesaleShippingMessages();
        normalizeCartPriceFormatting();
        normalizeDiscountColors();
        cleanupFutureDiscountMessages();
        return;
      }

      if (!discountCents && !hasCustomerPricing) {
        discountCents = getFallbackWsaioDiscountCents();
        if (!discountCents && (!window.cart_data || !Array.isArray(window.cart_data.items))) {
          discountCents = findWsaioFutureDiscountCents(form) || pageDiscountCents || getStoredWsaioDisplayDiscount(baseSubtotalCents);
        }
      }

      if (!discountCents || !baseSubtotalCents || discountCents >= baseSubtotalCents) {
        if (existingRow) existingRow.remove();
        totalRow.classList.remove('bf-wsaio-estimated-total-row');
        if (label) label.textContent = label.classList.contains('ajaxcart__subtotal') ? 'SUBTOTAL' : 'Subtotal';
        if (subtotal && subtotal.dataset && subtotal.dataset.bfBaseSubtotalCents) setMoneyHtmlIfDifferent(subtotal, Number(subtotal.dataset.bfBaseSubtotalCents));
        cleanupFutureDiscountMessages();
        return;
      }

      storeWsaioDisplayDiscount(baseSubtotalCents, discountCents);
      if (discountCents && !existingRow) {
        existingRow = document.createElement('div');
        existingRow.className = 'cart__item-sub cart__item-row bf-wsaio-applied-summary';
        existingRow.innerHTML = '<div data-bf-wsaio-discount-label></div><div class="text-right" data-bf-wsaio-discount></div>';
        totalRow.parentNode.insertBefore(existingRow, totalRow);
      }

      if (existingRow) {
        if (discountCents) {
          existingRow.querySelector('[data-bf-wsaio-discount-label]').textContent = orderDiscount && orderDiscount.label ? 'Discount code: ' + orderDiscount.label : getDiscountDisplayLabel();
          existingRow.querySelector('[data-bf-wsaio-discount]').innerHTML = '-' + formatMoney(discountCents);
          existingRow.style.setProperty('color', savingsColor, 'important');
          existingRow.querySelectorAll('*').forEach(function (element) {
            element.style.setProperty('color', savingsColor, 'important');
          });
        } else {
          existingRow.remove();
        }
      }

      totalRow.classList.add('bf-wsaio-estimated-total-row');
      if (label) label.textContent = 'Estimated total';
      setMoneyHtmlIfDifferent(subtotal, baseSubtotalCents - discountCents);
      normalizeWholesaleShippingMessages();
      normalizeCartPriceFormatting();
      normalizeDiscountColors();
      cleanupFutureDiscountMessages();
    });
  }

  function scheduleWsaioCartTotalNormalization() {
    if (!cartTotalDeadlineTimer) {
      cartTotalDeadlineTimer = window.setTimeout(function () {
        cartTotalDeadlineTimer = null;
        normalizeWsaioCartTotals();
      }, 80);
    }

    [40, 200, 700, 1600, 3600].forEach(function (delayMs, index) {
      window.clearTimeout(cartTotalTimers[index]);
      cartTotalTimers[index] = window.setTimeout(normalizeWsaioCartTotals, delayMs);
    });
  }

  function suppressRetailCartDiscountRowsForWholesale(form) {
    var discountContainer = form.querySelector('[data-discounts]');
    if (!discountContainer) return;

    if (!hasWsaioCustomerPricingAccess()) {
      discountContainer.style.display = '';
      discountContainer.dataset.bfHiddenForWholesale = '';
      return;
    }

    discountContainer.style.display = 'none';
    discountContainer.dataset.bfHiddenForWholesale = 'true';
  }

  function suppressRetailLineDiscountLabelsForWholesale(form) {
    var hasCustomerPricing = hasWsaioCustomerPricingAccess();

    form.querySelectorAll('.cart__discount').forEach(function (element) {
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      var isRetailDiscount = /save25dried|25%\s*off\s*\$?150|25%\s*off\s*retail|preserved\s*\+\s*dried/i.test(text);

      if (hasCustomerPricing && isRetailDiscount) {
        element.dataset.bfHiddenRetailDiscountForWholesale = 'true';
        element.style.display = 'none';
        return;
      }

      if (element.dataset.bfHiddenRetailDiscountForWholesale === 'true') {
        delete element.dataset.bfHiddenRetailDiscountForWholesale;
        element.style.display = '';
      }
    });
  }

  function cleanupFutureDiscountMessages() {
    normalizeWholesaleShippingMessages();

    document.querySelectorAll('#CartPageForm [data-wsaio-messages], #CartDrawer [data-wsaio-messages], #CartPageForm [class*="wsaio" i], #CartDrawer [class*="wsaio" i]').forEach(function (element) {
      if (element.classList && element.classList.contains('bf-wsaio-applied-summary')) return;

      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (hasWsaioCustomerPricingAccess() && /save25dried|25%\s*off|retail orders|additional\s+\$?\s*[\d,.]+\s+discount\s+will\s+be\s+applied\s+at\s+checkout/i.test(text)) {
        element.dataset.bfHiddenRetailDiscountForWholesale = 'true';
        element.style.display = 'none';
        return;
      }

      if (/additional\s+\$?\s*[\d,.]+\s+discount\s+will\s+be\s+applied\s+at\s+checkout/i.test(text)) {
        element.dataset.bfHiddenFutureDiscountMessage = 'true';
        element.style.display = 'none';
      }
    });
  }

  function hideFutureDiscountMessagesImmediately() {
    document.querySelectorAll('#CartPageForm [data-wsaio-messages], #CartDrawer [data-wsaio-messages], #CartPageForm [class*="wsaio" i], #CartDrawer [class*="wsaio" i]').forEach(function (element) {
      if (element.classList && element.classList.contains('bf-wsaio-applied-summary')) return;

      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/additional\s+\$?\s*[\d,.]+\s+discount\s+will\s+be\s+applied\s+at\s+checkout/i.test(text)) return;

      element.dataset.bfHiddenFutureDiscountMessage = 'true';
      element.style.display = 'none';
    });
  }

  function getCartShippingMessage() {
    var cart = window.cart_data;
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var freshCount;
    var bouquetCount;

    if (!items.length) return '';

    freshCount = items.filter(isFreshCartItem).length;
    bouquetCount = items.filter(isBouquetCartItem).length;

    if (items.length && freshCount === items.length) return freshShippingMessage;
    if (items.length && bouquetCount === items.length) return bouquetShippingMessage;
    if (freshCount > 0) return mixedShippingMessage;
    return wholesaleShippingMessage;
  }

  function isFreshCartItem(item) {
    if (String(item && item.product_id || '').replace('gid://shopify/Product/', '') === '15405744521367') return true;
    var handle = String(item && item.handle || '').toLowerCase();
    var productType = String(item && item.product_type || '').toLowerCase();
    var title = String(item && item.product_title || item && item.title || '').toLowerCase();

    return /^fresh-/.test(handle) ||
      /(^|\s)fresh(\s|$)/.test(productType) ||
      (/\bfresh\b/.test(title) && !/preserved|dried/.test(title)) ||
      /custom-garland/.test(handle);
  }

  function isBouquetCartItem(item) {
    var handle = String(item && item.handle || '').toLowerCase();
    var productType = String(item && item.product_type || '').toLowerCase();
    var title = String(item && item.product_title || item && item.title || '').toLowerCase();

    return /(^|[-_])bouquet(s)?($|[-_])/.test(handle) ||
      /\bbouquet(s)?\b/.test(productType) ||
      /\bbouquet(s)?\b/.test(title);
  }

  function cartContainsOnlyFreshItems(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.length > 0 && items.every(isFreshCartItem);
  }

  function installShippingMessagePaintGuard() {
    var style;

    if (document.getElementById('bf-shipping-message-paint-guard')) return;
    style = document.createElement('style');
    style.id = 'bf-shipping-message-paint-guard';
    style.textContent = '#CartDrawer [class*="shipping_msg" i],#CartPageForm [class*="shipping_msg" i]{visibility:hidden;min-height:1.35em}' +
      '#CartDrawer [class*="shipping_msg" i][data-bf-wholesale-shipping-message="true"],#CartPageForm [class*="shipping_msg" i][data-bf-wholesale-shipping-message="true"]{visibility:visible}';
    (document.head || document.documentElement).appendChild(style);
  }

  function findCartShippingMessageElement(target) {
    var element = target && target.nodeType === 1 ? target : target && target.parentElement;

    while (element && element !== document.documentElement) {
      if (/shipping_msg/i.test(String(element.className || ''))) return element;
      element = element.parentElement;
    }

    return null;
  }

  function setShippingMessageStyle(element, property, value, priority) {
    var expectedPriority = priority || '';

    if (
      element.style.getPropertyValue(property) === value &&
      element.style.getPropertyPriority(property) === expectedPriority
    ) return;

    element.style.setProperty(property, value, expectedPriority);
  }

  function hideCartShippingMessageUntilResolved(element) {
    if (!element) return;
    if (element.hasAttribute('data-bf-wholesale-shipping-message')) {
      element.removeAttribute('data-bf-wholesale-shipping-message');
    }
    setShippingMessageStyle(element, 'visibility', 'hidden', 'important');
    setShippingMessageStyle(element, 'min-height', '1.35em');
  }

  function refreshCartShippingMessage(element) {
    var expected = getCartShippingMessage();
    var current = String(element && element.textContent || '').replace(/\s+/g, ' ').trim();

    if (expected && current === expected) {
      if (element.getAttribute('data-bf-wholesale-shipping-message') !== 'true') {
        element.setAttribute('data-bf-wholesale-shipping-message', 'true');
      }
      setShippingMessageStyle(element, 'visibility', 'visible', 'important');
      return;
    }

    hideCartShippingMessageUntilResolved(element);
    lastCartFetchAt = 0;
    refreshCartData().then(function (cart) {
      if (cart && Array.isArray(cart.items)) normalizeWholesaleShippingMessages();
    });
  }

  function normalizeWholesaleShippingMessages() {
    var visibleByScope = [];
    var cartShippingMessage = getCartShippingMessage();

    document.querySelectorAll('.Shipping_msg, [class*="Shipping_msg"], [class*="shipping_msg" i]').forEach(function (element) {
      var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/wholesale|handling fee|expedited|shipping/i.test(text)) return;

      var scope = element.closest('#CartDrawer, #CartPageForm, .drawer, .cart, form') || document.body;
      var existing = visibleByScope.filter(function (entry) {
        return entry.scope === scope;
      })[0];

      if (existing) {
        if (element.getAttribute('data-bf-wholesale-shipping-duplicate') !== 'true') {
          element.setAttribute('data-bf-wholesale-shipping-duplicate', 'true');
        }
        setShippingMessageStyle(element, 'display', 'none');
        hideCartShippingMessageUntilResolved(element);
        return;
      }

      visibleByScope.push({ scope: scope, element: element });

      if (!cartShippingMessage) {
        hideCartShippingMessageUntilResolved(element);
        return;
      }

      if (text !== cartShippingMessage) element.textContent = cartShippingMessage;
      if (element.hasAttribute('data-bf-wholesale-shipping-duplicate')) {
        element.removeAttribute('data-bf-wholesale-shipping-duplicate');
      }
      setShippingMessageStyle(element, 'display', '');
      setShippingMessageStyle(element, 'color', '#5f7459', 'important');
      setShippingMessageStyle(element, 'font-weight', '600', 'important');
      setShippingMessageStyle(element, 'font-style', 'normal', 'important');
      setShippingMessageStyle(element, 'visibility', 'visible', 'important');
      setShippingMessageStyle(element, 'min-height', '1.35em');
      if (element.getAttribute('data-bf-wholesale-shipping-message') !== 'true') {
        element.setAttribute('data-bf-wholesale-shipping-message', 'true');
      }
    });
  }

  function normalizeDiscountColors() {
    normalizeCartPriceFormatting();

    document.querySelectorAll('#CartDrawer .cart__item-price-col .bf-cart-discount-price, #CartDrawerForm .cart__item-price-col .bf-cart-discount-price, #CartPageForm .cart__item-price-col .bf-cart-discount-price, #CartDrawer .cart__item-price-col .cart__discount:not(small), #CartDrawerForm .cart__item-price-col .cart__discount:not(small), #CartPageForm .cart__item-price-col .cart__discount:not(small), #CartDrawer .cart__discount, #CartDrawerForm .cart__discount, #CartPageForm .cart__discount, #CartDrawer .cart__discounts, #CartDrawerForm .cart__discounts, #CartPageForm .cart__discounts, #CartDrawer .cart__discounts *, #CartDrawerForm .cart__discounts *, #CartPageForm .cart__discounts *, #CartDrawer .bf-wsaio-applied-summary, #CartDrawerForm .bf-wsaio-applied-summary, #CartPageForm .bf-wsaio-applied-summary, #CartDrawer .bf-wsaio-applied-summary *, #CartDrawerForm .bf-wsaio-applied-summary *, #CartPageForm .bf-wsaio-applied-summary *, #CartDrawer [data-bf-wsaio-discount], #CartDrawerForm [data-bf-wsaio-discount], #CartPageForm [data-bf-wsaio-discount], #CartDrawer [data-bf-wsaio-discount-label], #CartDrawerForm [data-bf-wsaio-discount-label], #CartPageForm [data-bf-wsaio-discount-label], #CartDrawer [class*="discount" i], #CartDrawerForm [class*="discount" i], #CartPageForm [class*="discount" i]').forEach(function (element) {
      element.style.setProperty('color', savingsColor, 'important');
    });
  }

  function extractVisibleWsaioDiscountCode(form) {
    var messageText = '';
    var match;

    form.querySelectorAll('[data-wsaio-messages], .bf-wsaio-applied-summary, [class*="wsaio" i]').forEach(function (element) {
      if (element.offsetParent !== null) messageText += '\n' + element.textContent;
    });

    match = messageText.match(/discount\s+code:\s*([A-Z0-9_-]+)/i);
    return match ? match[1].toUpperCase().replace(/[-_]+$/, '') : '';
  }

  function hasVisibleWsaioDiscount(form) {
    var discountAmount = form.querySelector('[data-bf-wsaio-discount]');
    var wsaioMessage = form.querySelector('[data-wsaio-messages], .bf-wsaio-applied-summary, [class*="wsaio" i]');

    if (extractVisibleWsaioDiscountCode(form)) return true;
    if (discountAmount && /-\s*\$?\s*\d/i.test(discountAmount.textContent || '')) return true;
    if (wsaioMessage && /discount/i.test(wsaioMessage.textContent || '')) return true;

    return false;
  }

  function syncWsaioDiscountInputs() {
    document.querySelectorAll('#CartPageForm, #CartDrawerForm').forEach(function (form) {
      var code = extractVisibleWsaioDiscountCode(form);
      var input = form.querySelector('input[name="discount"][data-bf-wsaio-discount-input]');

      removeIneligibleDiscountInputs(form);

      if (hasWs01Access() || hasWsaioCustomerPricingAccess()) {
        if (input && !getAllowedWsaioOrderDiscountCodes()[String(input.value || '').trim().toUpperCase()]) input.remove();
        return;
      }

      if (!code) {
        if (input) input.remove();
        return;
      }

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'discount';
        input.setAttribute('data-bf-wsaio-discount-input', 'true');
        form.appendChild(input);
      }

      input.value = code;
    });
  }

  function checkoutControlIsVisible(element) {
    var rect;
    var style;

    if (!element) return false;

    style = window.getComputedStyle(element);
    rect = element.getBoundingClientRect();

    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity) !== 0 &&
      rect.width > 0 &&
      rect.height > 0;
  }

  function getCheckoutControls(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[name="checkout"], [name="waio_addToCart"], .cart__checkout, a[href*="/checkout"], button[class*="checkout" i], input[type="submit"][value*="checkout" i], input[type="submit"][value*="check out" i]'));
  }

  function runWsaioBeforeCheckout(form) {
    if (!needsWsaioDraftCheckout(form)) return;

    try {
      syncWsaioCustomerFromStorefront();
      syncWholesaleSelectors();
      wrapWsaioCheckoutRequests();
      syncWsaioDiscountInputs();
      clearIneligibleWsaioRuntimeDiscounts();
      if (window.WSAIO) {
        if (typeof window.WSAIO.load_checkout_restriction === 'function') window.WSAIO.load_checkout_restriction();
        if (typeof window.WSAIO.checkout_restriction === 'function') window.WSAIO.checkout_restriction();
        if (typeof window.WSAIO.preCheckout_without_fetch === 'function' && hasWsaioCustomerPricingAccess()) window.WSAIO.preCheckout_without_fetch();
        if (typeof window.WSAIO.run_checkout === 'function') window.WSAIO.run_checkout();
      }
    } catch (error) {
      console.warn('Wholesale All In One checkout refresh failed', error);
    }
  }

  function wsaioCheckoutRuntimeUnavailable(form) {
    return Boolean(
      form &&
      (hasWsaioCustomerPricingAccess() || getRuscusWednesdayShippingFee(window.cart_data) > 0) &&
      (!window.WSAIO || typeof window.WSAIO.checkout !== 'function')
    );
  }

  function getWsaioCartPricingVerification(form) {
    var cart = window.cart_data;
    var verification = {
      required: hasWsaioCustomerPricingAccess(),
      settled: true,
      expectedSubtotalCents: 0,
      displayedSubtotalCents: 0,
      mismatchCount: 0
    };

    if (!verification.required) return verification;
    if (!form || !cart || !Array.isArray(cart.items) || !cart.items.length) {
      verification.settled = false;
      verification.mismatchCount = 1;
      return verification;
    }

    cart.items.forEach(function (item) {
      var itemElement = null;
      var originalUnitPriceCents = Number(item && (item.original_price || item.price)) || 0;
      var finalUnitPriceCents = Number(item && (item.final_price || item.price || item.original_price)) || 0;
      var fixedUnitPriceCents = getWsaioFixedUnitPriceCents(item);
      var expectedUnitPriceCents = fixedUnitPriceCents && fixedUnitPriceCents < originalUnitPriceCents
        ? fixedUnitPriceCents
        : finalUnitPriceCents;
      var displayedUnitPriceCents;
      var quantity = Number(item && item.quantity) || 0;

      Array.prototype.some.call(form.querySelectorAll('.cart__item'), function (candidate) {
        if (candidate.getAttribute('data-key') !== item.key) return false;
        itemElement = candidate;
        return true;
      });

      verification.expectedSubtotalCents += expectedUnitPriceCents * quantity;
      displayedUnitPriceCents = getDisplayedCartItemUnitPriceCents(itemElement);
      if (!itemElement || !expectedUnitPriceCents || displayedUnitPriceCents !== expectedUnitPriceCents) {
        verification.settled = false;
        verification.mismatchCount += 1;
      }
    });

    var orderDiscount = getBestWsaioOrderDiscount(verification.expectedSubtotalCents);
    if (orderDiscount) verification.expectedSubtotalCents -= orderDiscount.discountCents;

    // WSAIO may replace the drawer footer and drop the theme's data-subtotal
    // marker. Validate the visible total cell as a fallback so a correct Fresh
    // cart is not trapped behind a false $0 subtotal mismatch.
    var subtotalElement = form.querySelector('[data-subtotal], .total.row > :last-child, .bf-wsaio-estimated-total-row > :last-child');
    verification.displayedSubtotalCents = parseMoneyCents(subtotalElement && subtotalElement.textContent);
    if (!subtotalElement || verification.displayedSubtotalCents !== verification.expectedSubtotalCents) {
      verification.settled = false;
      verification.mismatchCount += 1;
    }

    return verification;
  }

  function showWsaioCheckoutPricingMessage(form) {
    var wrapper = form && form.querySelector('.cart__checkout-wrapper, .Cart__Footer');
    var message;

    if (!wrapper) return;
    message = wrapper.querySelector('.bf-wsaio-pricing-pending');
    if (!message) {
      message = document.createElement('p');
      message.className = 'bf-wsaio-pricing-pending';
      message.setAttribute('role', 'alert');
      wrapper.insertBefore(message, wrapper.firstChild);
    }
    message.textContent = 'We are refreshing your wholesale prices before checkout. Please wait a moment and select checkout again.';
  }

  function clearWsaioCheckoutPricingMessages(form) {
    if (!form) return;
    form.querySelectorAll('.bf-wsaio-pricing-pending').forEach(function (message) {
      message.remove();
    });
  }

  function showWsaioCheckoutRuntimeMessage(form) {
    var wrapper = form && form.querySelector('.cart__checkout-wrapper, .Cart__Footer');
    var message;

    if (!wrapper) return;
    message = wrapper.querySelector('.bf-wsaio-runtime-pending');
    if (!message) {
      message = document.createElement('p');
      message.className = 'bf-wsaio-runtime-pending';
      message.setAttribute('role', 'alert');
      wrapper.insertBefore(message, wrapper.firstChild);
    }
    message.textContent = getRuscusWednesdayShippingFee(window.cart_data) > 0 ? 'Delivery pricing is still loading. Please wait a moment and select checkout again.' : 'Wholesale pricing is still loading. Please wait a moment and select checkout again.';
  }

  function clearWsaioCheckoutRuntimeMessages() {
    if (!window.WSAIO || typeof window.WSAIO.checkout !== 'function') return;
    document.querySelectorAll('.bf-wsaio-runtime-pending').forEach(function (message) {
      message.remove();
    });
  }
  function getRuscusDeliveryDateIssue(cart, now) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var ruscus = items.filter(function (item) {
      var id = String(item && item.product_id || '').replace('gid://shopify/Product/', '');
      return id === '15405744521367' || String(item && item.handle || '').toLowerCase() === 'fresh-italian-ruscus';
    });
    if (!ruscus.length) return '';
    var api = window.BloomingfulDeliveryAvailability;
    if (!api || typeof api.parseYmd !== 'function' || typeof api.freshEarliest !== 'function' || typeof api.isFreshDeliveryDay !== 'function') {
      return 'Delivery dates are still loading. Please wait a moment and try checkout again.';
    }
    var mode = 'fresh-bunch-week-ahead';
    var earliest = api.freshEarliest(mode, now || new Date());
    return ruscus.some(function (item) {
      var date = api.parseYmd(getCartItemProperty(item, 'Requested delivery date'));
      return !date || date < earliest || !api.isFreshDeliveryDay(mode, date);
    }) ? 'Please remove Italian Ruscus from your cart and add it again with an available delivery date. Orders must be placed by Sunday for the following Wednesday through Saturday.' : '';
  }

  function guardRuscusDeliveryDate(event, form) {
    if (!form) return false;
    var issue = getRuscusDeliveryDateIssue(window.cart_data);
    form.querySelectorAll('.bf-ruscus-delivery-date-error').forEach(function (node) { node.remove(); });
    if (!issue) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    var message = document.createElement('p');
    message.className = 'bf-ruscus-delivery-date-error';
    message.setAttribute('role', 'alert');
    message.tabIndex = -1;
    message.appendChild(document.createTextNode(issue + ' '));
    var link = document.createElement('a');
    link.href = '/products/fresh-italian-ruscus';
    link.textContent = 'Choose a delivery date';
    message.appendChild(link);
    var wrapper = form.querySelector('.cart__checkout-wrapper, .Cart__Footer') || form;
    wrapper.insertBefore(message, wrapper.firstChild);
    message.focus();
    return true;
  }

  function routeThroughWsaioCheckout(event, control) {
    var form = control && control.closest ? control.closest('#CartPageForm, #CartDrawerForm') : null;
    var pricingVerification;

    if (guardRuscusDeliveryDate(event, form)) return true;

    window.bloomingfulWsaioCheckoutProbe = window.bloomingfulWsaioCheckoutProbe || [];
    runWsaioBeforeCheckout(form);
    syncWsaioVisibleLinePrices();
    normalizeWsaioCartTotals();
    pricingVerification = getWsaioCartPricingVerification(form);

    window.bloomingfulWsaioCheckoutProbe.push({
      at: Date.now(),
      controlText: control && (control.innerText || control.value),
      hasForm: Boolean(form),
      needsDraft: needsWsaioDraftCheckout(form),
      hasLineAdjustment: hasWsaioLinePricingAdjustment(),
      hasShippingRule: hasMatchingWsaioShippingRule(),
      hasCustomerPricing: hasWsaioCustomerPricingAccess(),
      pricingSettled: pricingVerification.settled,
      pricingMismatchCount: pricingVerification.mismatchCount,
      pricingExpectedSubtotalCents: pricingVerification.expectedSubtotalCents,
      pricingDisplayedSubtotalCents: pricingVerification.displayedSubtotalCents
    });

    if (wsaioCheckoutRuntimeUnavailable(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      showWsaioCheckoutRuntimeMessage(form);
      scheduleWholesaleChecks();
      return true;
    }

    if (pricingVerification.required && !pricingVerification.settled) {
      lastCartFetchAt = 0;
      refreshCartData().then(function () {
        syncWsaioVisibleLinePrices();
        normalizeWsaioCartTotals();
      });
      scheduleWholesaleChecks();
    }

    clearWsaioCheckoutPricingMessages(form);
    if (!needsWsaioDraftCheckout(form)) return false;

    syncWsaioDiscountInputs();
    clearIneligibleWsaioRuntimeDiscounts();
    wrapWsaioCheckoutRequests();
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if (control && control.setAttribute) control.setAttribute('disabled', 'disabled');

    try {
      window.WSAIO.checkout();
    } catch (error) {
      console.warn('Wholesale All In One checkout failed', error);
      if (control && control.removeAttribute) control.removeAttribute('disabled');
    }

    return true;
  }

  function bindDelegatedCheckoutControls() {
    if (delegatedCheckoutBound) return;
    delegatedCheckoutBound = true;
    window.bloomingfulWsaioDelegatedCheckoutBound = true;

    document.addEventListener('click', function (event) {
      var control = event.target && event.target.closest && event.target.closest('#CartPageForm [name="checkout"], #CartDrawerForm [name="checkout"], #CartPageForm [name="waio_addToCart"], #CartDrawerForm [name="waio_addToCart"], #CartPageForm .cart__checkout, #CartDrawerForm .cart__checkout');
      if (!control) return;
      routeThroughWsaioCheckout(event, control);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target && event.target.closest && event.target.closest('#CartPageForm, #CartDrawerForm');
      var control;

      if (!form) return;
      control = form.querySelector('[name="checkout"], .cart__checkout');
      routeThroughWsaioCheckout(event, control);
    }, true);
  }

  function bindCheckoutControl(control) {
    if (!control || control.dataset.bfWsaioCheckoutBound === 'true') return;

    control.dataset.bfWsaioCheckoutBound = 'true';
  }

  function preferredCheckoutControl(controls, scope) {
    var form = scope.matches && scope.matches('#CartPageForm, #CartDrawerForm')
      ? scope
      : scope.querySelector && scope.querySelector('#CartPageForm, #CartDrawerForm');
    var requiresWsaio = needsWsaioDraftCheckout(form);
    var themeControls = controls.filter(function (control) {
      return control.getAttribute('name') !== 'waio_addToCart' &&
        (!control.classList || !control.classList.contains('bf-wsaio-checkout-fallback'));
    });
    var wsaioControls = controls.filter(function (control) {
      return control.getAttribute('name') === 'waio_addToCart';
    });
    var fallbackControls = controls.filter(function (control) {
      return control.classList && control.classList.contains('bf-wsaio-checkout-fallback');
    });
    var visibleTheme = themeControls.filter(checkoutControlIsVisible);
    var visibleWsaio = wsaioControls.filter(checkoutControlIsVisible);
    var visibleFallback = fallbackControls.filter(checkoutControlIsVisible);
    var visibleControls = controls.filter(checkoutControlIsVisible);

    if (requiresWsaio) {
      return visibleWsaio[0] || visibleTheme[0] || visibleFallback[0] || visibleControls[0] || wsaioControls[0] || themeControls[0] || fallbackControls[0] || controls[0] || null;
    }

    return visibleTheme[0] || visibleFallback[0] || visibleWsaio[0] || visibleControls[0] || themeControls[0] || fallbackControls[0] || wsaioControls[0] || controls[0] || null;
  }

  function dedupeCheckoutControls(scope) {
    var controls = getCheckoutControls(scope);
    var primary = preferredCheckoutControl(controls, scope);

    controls.forEach(function (control) {
      if (primary && control !== primary) {
        control.remove();
        return;
      }
      bindCheckoutControl(control);
    });
  }

  function dedupeWsaioAlerts() {
    document.querySelectorAll('#CartPageForm, #CartDrawerForm').forEach(function (form) {
      var seen = {};

      form.querySelectorAll('.wsaio_alerts_div .wsaio-alerts').forEach(function (alert) {
        var signature;

        if (alert.dataset.bfWsaioAlertDuplicate === 'true') {
          alert.style.removeProperty('display');
          delete alert.dataset.bfWsaioAlertDuplicate;
        }

        signature = alert.tagName + '|' + String(alert.textContent || '').replace(/\s+/g, ' ').trim();
        if (!signature || signature === alert.tagName + '|') return;

        if (seen[signature]) {
          alert.dataset.bfWsaioAlertDuplicate = 'true';
          alert.style.setProperty('display', 'none', 'important');
          return;
        }

        seen[signature] = true;
      });
    });
  }

  function ensureCheckoutControls() {
    dedupeWsaioAlerts();
    document.querySelectorAll('#CartDrawer, #CartPageForm, #CartDrawerForm').forEach(dedupeCheckoutControls);
    dedupeWsaioAlerts();

    document.querySelectorAll('#CartPageForm, #CartDrawerForm').forEach(function (form) {
      var wrapper = form.querySelector('.cart__checkout-wrapper, .Cart__Footer');
      var controls = getCheckoutControls(form);
      var requiresWsaio = needsWsaioDraftCheckout(form);
      var eligibleControls = controls.filter(function (control) {
        return requiresWsaio || control.getAttribute('name') !== 'waio_addToCart';
      });
      var visibleEligibleControls = eligibleControls.filter(checkoutControlIsVisible);
      var fallback;

      if (!wrapper) return;
      if (visibleEligibleControls.length) return;

      fallback = document.createElement('button');
      fallback.type = 'submit';
      fallback.name = 'checkout';
      fallback.className = 'btn cart__checkout bf-wsaio-checkout-fallback';
      fallback.textContent = 'CHECK OUT';
      fallback.setAttribute('data-terms-required', 'false');

      bindCheckoutControl(fallback);
      wrapper.appendChild(fallback);
    });

    document.querySelectorAll('#CartDrawer, #CartPageForm, #CartDrawerForm').forEach(dedupeCheckoutControls);
    dedupeWsaioAlerts();
  }

  function scheduleCheckoutControlCleanup() {
    ensureCheckoutControls();
    window.setTimeout(ensureCheckoutControls, 100);
    window.setTimeout(ensureCheckoutControls, 350);
    window.setTimeout(ensureCheckoutControls, 900);
    window.setTimeout(ensureCheckoutControls, 1800);
  }

  function scheduleCheckoutDeduplication() {
    window.clearTimeout(checkoutCleanupTimer);
    checkoutCleanupTimer = window.setTimeout(ensureCheckoutControls, 50);
  }

  function syncWholesaleSelectors() {
    if (!window.WSAIO) return;

    window.WSAIO.checkout_selector = '#CartPageForm [name="checkout"], #CartDrawer [name="checkout"], .cart__checkout';
    window.WSAIO.checkout_message_selector = '#CartPageForm .cart__checkout-wrapper, #CartDrawer .cart__checkout-wrapper, .cart__checkout-wrapper';
    window.WSAIO.replace_checkout_button = '#CartPageForm [name="checkout"], #CartDrawer [name="checkout"]';
    window.WSAIO.cart_ld_selector = '#CartPageForm [data-wsaio-messages], #CartDrawer [data-wsaio-messages], #CartPageForm .Cart__Footer:before, #CartDrawer .Cart__Footer:before';
    window.WSAIO.cart_items_each_selector = '#CartPageForm .cart__item, #CartDrawer .cart__item, .cart__item';
    window.WSAIO.cart_item_total_selector = '.cart__item-price-col .bf-cart-discount-price, .cart__item-price-col .cart__discount:not(small), .cart__item-price-col .cart__price:not(.cart__price--strikethrough)';
    window.WSAIO.cart_item_price_selector = '.cart__item-price-col .bf-cart-discount-price, .cart__item-price-col .cart__discount:not(small), .cart__item-price-col .cart__price:not(.cart__price--strikethrough)';
    window.WSAIO.cart_item_saved_price_selector = '.ws-item-saved-price';
    window.WSAIO.discount_code_field_selector = '#CartPageForm .total.row:before, #CartDrawer .total.row:before';
    window.WSAIO.discount_code_link_selector = '#CartDrawer .total.row:before, #CartPageForm .total.row:before';
    window.WSAIO.cart_qty_change_selector = '#CartPageForm [name="updates[]"], #CartDrawer [name="updates[]"], [name="quantity"]';
    window.WSAIO.cart_qty_btn_selector = '#CartPageForm .js-qty__adjust, #CartDrawer .js-qty__adjust';
    window.WSAIO.cart_qty_input_selector = '#CartPageForm .js-qty__num, #CartDrawer .js-qty__num';
  }

  function scheduleWholesaleChecks() {
    window.clearTimeout(retryTimer);
    retryTimer = window.setTimeout(function () {
      runWholesaleChecks();
      normalizeWsaioCartTotals();
      normalizeDiscountColors();
      scheduleCheckoutControlCleanup();
      syncWsaioDiscountInputs();
      window.setTimeout(runWholesaleChecks, 150);
      window.setTimeout(runWholesaleChecks, 350);
      window.setTimeout(runWholesaleChecks, 800);
      window.setTimeout(runWholesaleChecks, 1800);
      window.setTimeout(runWholesaleChecks, 3200);
      window.setTimeout(normalizeWsaioCartTotals, 3600);
      window.setTimeout(normalizeDiscountColors, 3625);
      window.setTimeout(scheduleCheckoutControlCleanup, 3650);
      window.setTimeout(syncWsaioDiscountInputs, 3675);
    }, 250);
  }

  function refreshWsaioCollectionCards() {
    var hasSupportedPageGrid = Boolean(document.querySelector('[data-bf-wsaio-collection-grid]'));
    var hasSupportedTemplate = /^(collection|search|index)$/.test(String(window.WSAIO && window.WSAIO.template || ''));
    if (!window.WSAIO || (!hasSupportedTemplate && !hasSupportedPageGrid)) return;

    // Bloomingful's signed live feed owns card pricing. Calling WSAIO's native
    // renderer here caused retail, single-tier, and range prices to overwrite
    // one another several seconds after a collection became visible.
    normalizeWsaioCollectionCardPrices();
  }

  function getWsaioCollectionCardVariantItems(card) {
    var productId = String(card && card.getAttribute('data-product-id') || '');
    var handle = String(card && card.getAttribute('data-product-handle') || '');
    var variantControl = card && card.querySelector('[data-bf-preserved-variant-select]');
    var quantityInput = card && card.querySelector('[data-bf-preserved-quantity]');
    var selectedVariantId = String(variantControl && variantControl.value || '');
    var selectedQuantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
    var itemsByKey = {};

    function addItem(variantId, sku, originalPriceCents) {
      var key = String(variantId || sku || 'default');
      var priceCents = Number(originalPriceCents) || 0;

      if (!priceCents || itemsByKey[key]) return;
      itemsByKey[key] = {
        product_id: productId,
        variant_id: String(variantId || ''),
        id: String(variantId || ''),
        sku: String(sku || ''),
        handle: handle,
        original_price: priceCents,
        price: priceCents,
        quantity: selectedQuantity
      };
    }

    addItem(
      card && card.getAttribute('data-bf-wsaio-variant-id'),
      card && card.getAttribute('data-bf-wsaio-variant-sku'),
      card && card.getAttribute('data-bf-wsaio-variant-price')
    );

    mergeWsaioRuleSources().forEach(function (rule) {
      if (!ruleAppliesToCustomer(rule)) return;

      (rule.products || []).forEach(function (productRule) {
        var productMatches = String(productRule.id || '') === productId || String(productRule.handle || '') === handle;
        if (!productMatches) return;

        (productRule.variants || []).forEach(function (variantRule) {
          if (selectedVariantId && String(variantRule.id || '') !== selectedVariantId) return;
          addItem(
            variantRule.id,
            variantRule.sku,
            Math.round((Number(variantRule.price) || 0) * 100)
          );
        });
      });
    });

    return Object.keys(itemsByKey).map(function (key) {
      return itemsByKey[key];
    });
  }

  function getWsaioCollectionCardPrice(card) {
    var items = getWsaioCollectionCardVariantItems(card);
    var wholesalePriceCents = 0;
    var retailPriceCents = 0;
    var retailPrices = {};

    items.forEach(function (item) {
      var originalCents = originalUnitPriceCents(item);
      var resolvedCents = getWsaioFixedUnitPriceCents(item);

      if (originalCents) {
        retailPrices[String(originalCents)] = true;
        if (!retailPriceCents || originalCents < retailPriceCents) retailPriceCents = originalCents;
      }
      if (resolvedCents && (!wholesalePriceCents || resolvedCents < wholesalePriceCents)) {
        wholesalePriceCents = resolvedCents;
      }
    });

    if (!wholesalePriceCents || !retailPriceCents || wholesalePriceCents >= retailPriceCents) return null;

    return {
      wholesalePriceCents: wholesalePriceCents,
      retailPriceCents: retailPriceCents,
      varies: Object.keys(retailPrices).length > 1
    };
  }

  function getWsaioCollectionCardRange(card) {
    var items = getWsaioCollectionCardVariantItems(card);
    var candidates = [];
    var retailCandidates;
    var bestSpecificity = 0;

    items.forEach(function (item) {
      mergeWsaioRuleSources().forEach(function (rule) {
        if (!ruleAppliesToCustomer(rule)) return;
        collectWsaioFixedPriceCandidates(rule, item).forEach(function (candidate) {
          if (!candidate.priceCents || !candidate.specificity) return;
          bestSpecificity = Math.max(bestSpecificity, candidate.specificity);
          candidates.push({
            priceCents: candidate.priceCents,
            qty: candidate.qty,
            specificity: candidate.specificity,
            retailPriceCents: originalUnitPriceCents(item)
          });
        });
      });
    });

    candidates = candidates.filter(function (candidate) {
      return candidate.specificity === bestSpecificity;
    });

    if (!candidates.length) return null;

    retailCandidates = candidates.map(function (candidate) {
      return candidate.retailPriceCents;
    }).filter(Boolean);

    return {
      minimumPriceCents: Math.min.apply(null, candidates.map(function (candidate) { return candidate.priceCents; })),
      maximumPriceCents: Math.max.apply(null, candidates.map(function (candidate) { return candidate.priceCents; })),
      retailMinimumPriceCents: retailCandidates.length ? Math.min.apply(null, retailCandidates) : 0,
      hasDiscount: candidates.some(function (candidate) {
        return candidate.retailPriceCents && candidate.priceCents < candidate.retailPriceCents;
      })
    };
  }

  function ensureWsaioCollectionPriceStyles() {
    if (document.getElementById('bf-wsaio-collection-price-styles')) return;

    var style = document.createElement('style');
    style.id = 'bf-wsaio-collection-price-styles';
    style.textContent = '.grid-product__price.bf-wsaio-collection-card-price{align-items:baseline;display:flex;flex-wrap:wrap;gap:3px 8px}.bf-wsaio-collection-price,.bf-fresh-price-range{color:#52715d;font-weight:700}.bf-wsaio-collection-retail{color:rgba(47,43,37,.58);font-size:.92em;text-decoration:line-through}.bf-wsaio-collection-fallback{align-items:baseline;display:flex;flex-wrap:wrap;gap:3px 8px}.grid-product__price[data-bf-wsaio-price-projection]>.bf-wsaio-collection-fallback,.grid-product__price[data-bf-wsaio-price-projection]>.wsaio_collection_discount,.grid-product__price[data-bf-wsaio-price-projection]>.wsaio_product_discount,.grid-product__price[data-bf-wsaio-price-projection]>*{display:none!important}.grid-product__price[data-bf-wsaio-price-projection]::before{color:rgba(47,43,37,.58);content:attr(data-bf-wsaio-retail-label);font-size:.92em;text-decoration:line-through}.grid-product__price[data-bf-wsaio-price-projection]::after{color:#52715d;content:attr(data-bf-wsaio-range-label);font-weight:700}.grid-product__price[data-bf-wsaio-price-projection=single]::before{display:none}';
    document.head.appendChild(style);
  }

  function renderFreshWsaioRange(priceElement, rangeText) {
    var rangeElement;

    if (!priceElement || !rangeText) return;

    priceElement.dataset.bfFreshRangeLabel = rangeText;
    rangeElement = priceElement.querySelector('[data-bf-fresh-wsaio-range]');
    if (!rangeElement) {
      priceElement.textContent = '';
      rangeElement = document.createElement('span');
      rangeElement.className = 'bf-fresh-price-range';
      rangeElement.setAttribute('data-bf-fresh-wsaio-range', '');
      rangeElement.setAttribute('aria-label', 'Current bunch price range');
      priceElement.appendChild(rangeElement);
    }

    rangeElement.setAttribute('data-bf-fresh-range-label', rangeText);
    if (String(rangeElement.textContent || '').trim() !== rangeText) rangeElement.textContent = rangeText;
  }

  function renderFreshGarlandStartingPrice(priceElement, startingPriceCents) {
    var label;
    var rangeElement;

    if (!priceElement || !startingPriceCents) return;

    label = 'Starting from ' + formatMoney(startingPriceCents).replace(/\$\s+/g, '$') + '+';
    rangeElement = priceElement.querySelector('[data-bf-fresh-garland-starting-price]');
    if (
      priceElement.dataset.bfFreshGarlandLabel === label &&
      rangeElement &&
      String(rangeElement.textContent || '').trim() === label &&
      priceElement.children.length === 1
    ) return;

    priceElement.textContent = '';
    priceElement.classList.remove('bf-wsaio-collection-card-price');
    priceElement.dataset.bfFreshGarlandLabel = label;
    rangeElement = document.createElement('span');
    rangeElement.className = 'bf-fresh-garland-starting-price';
    rangeElement.setAttribute('data-bf-fresh-garland-starting-price', '');
    rangeElement.setAttribute('aria-label', 'Starting price for a 4-foot garland');
    rangeElement.textContent = label;
    priceElement.appendChild(rangeElement);
  }

  function hasVisibleNativeWsaioCollectionPrice(card) {
    return Array.prototype.slice.call(card.querySelectorAll('.wsaio_collection_discount:not(.bf-wsaio-collection-fallback)')).some(function (element) {
      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();

      return Boolean(String(element.textContent || '').trim()) &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0;
    });
  }

  function normalizeWsaioCollectionCardPrices() {
    if (document.documentElement.getAttribute('data-bf-wsaio-live-pricing') === 'loading') return;
    ensureWsaioCollectionPriceStyles();

    document.querySelectorAll('.grid-product[data-bf-fresh-garland-card="true"]').forEach(function (card) {
      renderFreshGarlandStartingPrice(
        card.querySelector('.grid-product__price'),
        Number(card.getAttribute('data-bf-fresh-garland-starting-price')) || 14999
      );
    });

    // Each card is evaluated against its applicable WSAIO rules. This includes
    // temporary all-customer pricing while preserving tag-only rules for eligible shoppers.
    if (!window.bloomingfulWsaioStorefrontPricing && !window.bloomingfulWsaioRuleMap) return;

    document.querySelectorAll('.grid-product[data-product-id][data-product-handle]').forEach(function (card) {
      var priceElement = card.querySelector('.grid-product__price');
      var fallbackElement;
      var range;
      var rangeText;
      var signature;
      var isFreshFoliageCard = card.getAttribute('data-bf-fresh-foliage-card') === 'true';
      var isFreshGarlandCard = card.getAttribute('data-bf-fresh-garland-card') === 'true';

      if (!priceElement) return;
      if (isFreshGarlandCard) return;
      if (!priceElement.dataset.bfOriginalPriceMarkup) {
        priceElement.dataset.bfOriginalPriceMarkup = priceElement.innerHTML;
      }

      fallbackElement = priceElement.querySelector('.bf-wsaio-collection-fallback');
      range = getWsaioCollectionCardRange(card);
      if (!range || !range.hasDiscount) {
        if (fallbackElement || priceElement.dataset.bfWsaioCollectionPrice) {
          priceElement.innerHTML = priceElement.dataset.bfOriginalPriceMarkup || priceElement.innerHTML;
        }
        priceElement.classList.remove('bf-wsaio-collection-card-price');
        if (priceElement.dataset.bfWsaioPriceProjection) priceElement.removeAttribute('aria-label');
        delete priceElement.dataset.bfWsaioCollectionPrice;
        delete priceElement.dataset.bfFreshRangeLabel;
        delete priceElement.dataset.bfWsaioPriceProjection;
        delete priceElement.dataset.bfWsaioRetailLabel;
        delete priceElement.dataset.bfWsaioRangeLabel;
        return;
      }

      rangeText = formatMoney(range.minimumPriceCents).replace(/\$\s+/g, '$') +
        (range.maximumPriceCents > range.minimumPriceCents ? ' - ' + formatMoney(range.maximumPriceCents).replace(/\$\s+/g, '$') : '');

      if (isFreshFoliageCard) {
        signature = ['fresh', range.minimumPriceCents, range.maximumPriceCents].join(':');
        priceElement.dataset.bfWsaioPriceProjection = 'single';
        priceElement.dataset.bfWsaioRetailLabel = '';
        priceElement.dataset.bfWsaioRangeLabel = rangeText;
        priceElement.setAttribute('aria-label', rangeText + ' current price range');
        var freshRangeElement = priceElement.querySelector('[data-bf-fresh-wsaio-range]');
        if (
          priceElement.dataset.bfWsaioCollectionPrice === signature &&
          freshRangeElement &&
          priceElement.children.length === 1 &&
          String(freshRangeElement.textContent || '').trim() === rangeText
        ) return;

        priceElement.classList.add('bf-wsaio-collection-card-price');
        priceElement.dataset.bfWsaioCollectionPrice = signature;
        renderFreshWsaioRange(priceElement, rangeText);
        return;
      }

      signature = ['range', range.minimumPriceCents, range.maximumPriceCents, range.retailMinimumPriceCents].join(':');
      var retailElement = fallbackElement && fallbackElement.querySelector('.bf-wsaio-collection-retail');
      var wholesaleElement = fallbackElement && fallbackElement.querySelector('.bf-wsaio-collection-price');
      var expectedRetailText = range.retailMinimumPriceCents ? formatMoney(range.retailMinimumPriceCents) : '';
      priceElement.dataset.bfWsaioPriceProjection = 'range';
      priceElement.dataset.bfWsaioRetailLabel = expectedRetailText;
      priceElement.dataset.bfWsaioRangeLabel = rangeText;
      priceElement.setAttribute('aria-label', (expectedRetailText ? expectedRetailText + ' retail; ' : '') + rangeText + ' current price range');
      if (
        priceElement.dataset.bfWsaioCollectionPrice === signature &&
        fallbackElement &&
        priceElement.children.length === 1 &&
        priceElement.querySelectorAll('.bf-wsaio-collection-fallback').length === 1 &&
        priceElement.querySelectorAll('.wsaio_collection_discount:not(.bf-wsaio-collection-fallback)').length === 0 &&
        Boolean(retailElement) === Boolean(range.retailMinimumPriceCents) &&
        (!retailElement || String(retailElement.textContent || '').trim() === expectedRetailText) &&
        wholesaleElement &&
        String(wholesaleElement.textContent || '').trim() === rangeText
      ) return;

      priceElement.classList.add('bf-wsaio-collection-card-price');
      priceElement.dataset.bfWsaioCollectionPrice = signature;
      priceElement.innerHTML = '<span class="wsaio_collection_discount bf-wsaio-collection-fallback">' +
        (range.retailMinimumPriceCents ? '<span class="grid-product__price--original bf-wsaio-collection-retail">' + formatMoney(range.retailMinimumPriceCents) + '</span>' : '') +
        '<span class="bf-wsaio-collection-price" aria-label="Wholesale price range">' + rangeText + '</span>' +
        '<span class="grid-product__price--savings collection_save"></span>' +
        '</span>';
    });
  }

  function scheduleWsaioCollectionPriceNormalization(delayMs) {
    if (collectionPriceTimer) return;
    collectionPriceTimer = window.setTimeout(function () {
      collectionPriceTimer = null;
      normalizeWsaioCollectionCardPrices();
    }, Number(delayMs) || 80);
  }

  function initObserver() {
    if (observer) return;

    observer = new MutationObserver(function (mutations) {
      var collectionPricesNormalized = false;
      var cartUpdatesScheduled = false;
      for (var i = 0; i < mutations.length; i += 1) {
        var target = mutations[i].target;
        var elementTarget = target && target.nodeType === 1 ? target : target && target.parentElement;
        var freshRange = elementTarget && elementTarget.closest && elementTarget.closest('[data-bf-fresh-wsaio-range]');
        var freshCard = elementTarget && elementTarget.closest && elementTarget.closest('.grid-product[data-bf-fresh-foliage-card="true"]');
        var freshPriceElement = freshCard && (
          (elementTarget.closest && elementTarget.closest('.grid-product__price')) ||
          freshCard.querySelector('.grid-product__price')
        );
        var shippingMessageElement = findCartShippingMessageElement(elementTarget);

        if (shippingMessageElement) refreshCartShippingMessage(shippingMessageElement);

        if (freshPriceElement && freshPriceElement.dataset.bfFreshRangeLabel) {
          renderFreshWsaioRange(freshPriceElement, freshPriceElement.dataset.bfFreshRangeLabel);
        }

        if (
          freshRange &&
          !String(freshRange.textContent || '').trim() &&
          freshRange.getAttribute('data-bf-fresh-range-label')
        ) {
          freshRange.textContent = freshRange.getAttribute('data-bf-fresh-range-label');
        }

        if (elementTarget && elementTarget.closest && elementTarget.closest('.grid-product')) {
          if (document.documentElement.getAttribute('data-bf-wsaio-live-pricing') === 'loading') {
            scheduleWsaioCollectionPriceNormalization(90);
          } else if (!collectionPricesNormalized) {
            collectionPricesNormalized = true;
            // Coalesce a mutation burst into one full-grid pass before paint.
            // MutationObserver callbacks run before paint. Restore the signed
            // live range synchronously so late app writes cannot visibly flash.
            normalizeWsaioCollectionCardPrices();
          }
        }
        if (
          elementTarget &&
          elementTarget.closest &&
          (
            !cartUpdatesScheduled && elementTarget.closest('#CartDrawer') ||
            !cartUpdatesScheduled && elementTarget.closest('#CartPageForm') ||
            !cartUpdatesScheduled && elementTarget.matches('[data-products], [data-discounts], [data-subtotal]')
          )
        ) {
          cartUpdatesScheduled = true;
          scheduleCheckoutDeduplication();
          hideFutureDiscountMessagesImmediately();
          scheduleWsaioVisibleLinePriceNormalization();
          scheduleWsaioCartTotalNormalization();
          if (!isApplyingWsaioDomUpdates) scheduleWholesaleChecks();
          // Continue scanning: this batch may also contain collection price writes.
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function initBloomingfulWsaioCompat() {
    bindDelegatedCheckoutControls();
    initObserver();
    hideFutureDiscountMessagesImmediately();
    scheduleWholesaleChecks();
    scheduleWsaioVisibleLinePriceNormalization();
    scheduleWsaioCartTotalNormalization();
    scheduleWsaioCollectionPriceNormalization(400);
    window.setTimeout(refreshWsaioCollectionCards, 1200);
  }

  function handleCartMutation() {
    lastCartFetchAt = 0;
    document.querySelectorAll('#CartDrawer [class*="shipping_msg" i], #CartPageForm [class*="shipping_msg" i]').forEach(hideCartShippingMessageUntilResolved);
    scheduleWholesaleChecks();
  }

  installShippingMessagePaintGuard();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBloomingfulWsaioCompat);
  } else {
    initBloomingfulWsaioCompat();
  }
  window.addEventListener('load', scheduleWholesaleChecks);
  window.addEventListener('load', function () { scheduleWsaioCollectionPriceNormalization(100); });
  document.addEventListener('bloomingful:collection-hydrated', function () { scheduleWsaioCollectionPriceNormalization(100); });
  document.addEventListener('collection:reloaded', function () { scheduleWsaioCollectionPriceNormalization(100); });
  document.addEventListener('collection:updated', function () { scheduleWsaioCollectionPriceNormalization(100); });
  document.addEventListener('bloomingful:collection-variant-changed', function () { scheduleWsaioCollectionPriceNormalization(20); });
  document.addEventListener('bloomingful:wsaio-pricing-updated', normalizeWsaioCollectionCardPrices);
  document.addEventListener('ajaxProduct:added', handleCartMutation);
  document.addEventListener('cart:rebuilt', handleCartMutation);
  document.addEventListener('cart:quantity', handleCartMutation);
  document.addEventListener('cart:build', handleCartMutation);
  document.addEventListener('cart:updated', handleCartMutation);
  document.addEventListener('bloomingful:pricing-validation-failed', function () {
    syncWsaioVisibleLinePrices();
    scheduleWsaioVisibleLinePriceNormalization();
    scheduleWsaioCartTotalNormalization();
    scheduleWholesaleChecks();
  });

  var attempts = 0;
  var readyTimer = window.setInterval(function () {
    attempts += 1;
    if (runWholesaleChecks() || attempts >= 20) window.clearInterval(readyTimer);
  }, 500);
})();
